"use strict";
/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable
var loom_i18n_1 = require("loom-i18n");
var en_1 = require("loom-i18n/dist/locale-data/en");
var ar_1 = require("loom-i18n/dist/locale-data/ar");
var cs_1 = require("loom-i18n/dist/locale-data/cs");
var da_1 = require("loom-i18n/dist/locale-data/da");
var de_1 = require("loom-i18n/dist/locale-data/de");
var el_1 = require("loom-i18n/dist/locale-data/el");
var es_1 = require("loom-i18n/dist/locale-data/es");
var fi_1 = require("loom-i18n/dist/locale-data/fi");
var fr_1 = require("loom-i18n/dist/locale-data/fr");
var hr_1 = require("loom-i18n/dist/locale-data/hr");
var hu_1 = require("loom-i18n/dist/locale-data/hu");
var it_1 = require("loom-i18n/dist/locale-data/it");
var ja_1 = require("loom-i18n/dist/locale-data/ja");
var ko_1 = require("loom-i18n/dist/locale-data/ko");
var nl_1 = require("loom-i18n/dist/locale-data/nl");
var no_1 = require("loom-i18n/dist/locale-data/no");
var pl_1 = require("loom-i18n/dist/locale-data/pl");
var pt_1 = require("loom-i18n/dist/locale-data/pt");
var ro_1 = require("loom-i18n/dist/locale-data/ro");
var ru_1 = require("loom-i18n/dist/locale-data/ru");
var sk_1 = require("loom-i18n/dist/locale-data/sk");
var sl_1 = require("loom-i18n/dist/locale-data/sl");
var sr_1 = require("loom-i18n/dist/locale-data/sr");
var sv_1 = require("loom-i18n/dist/locale-data/sv");
var th_1 = require("loom-i18n/dist/locale-data/th");
var tr_1 = require("loom-i18n/dist/locale-data/tr");
var zh_1 = require("loom-i18n/dist/locale-data/zh");
var bundled = {};
bundled["en"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Close",
        cancel: "Cancel",
        help: "Help",
        loading: "Loading...",
        required: "Required",
        actions: "Actions",
        show: "Show",
        submit: "Submit",
        hide: "Hide",
        moreInfo: "More Information",
        expand: "Expand",
        collapse: "Collapse",
        remove: "Remove"
    },
    Alert: {
        danger: "Danger",
        info: "Info",
        success: "Success",
        warning: "Warning"
    },
    Breadcrumb: {
        breadcrumb: "Breadcrumb"
    },
    DatePicker: {
        time: "Time"
    },
    DetailTemplate: {
        resources: "Resources"
    },
    Errors: {
        unexpectedError: "An unexpected error occurred.",
        unexpectedServiceError: "An unexpected error from service occurred."
    },
    Field: {
        optional: "Optional",
        readOnly: "Read-Only"
    },
    FolderSelector: {
        browseLinkText: "Select a folder"
    },
    Clipboard: {
        copy: "Copy",
        copied: "Copied"
    },
    Pagination: {
        backToPage: "Back to Page {page, number, integer}",
        nextPage: "Next Page",
        nextToPage: "Next to Page {page, number, integer}",
        previousPage: "Previous Page",
        pageLocation: "{currentPage, number, integer} of {totalPages, number, integer}",
        pageLabel: "Page {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>in</em> {scope} <em>Compartment</em>"
    },
    ListTable: {
        itemsShowing: "Showing {items, number, integer} Items",
        itemsSelected: "{items, number, integer} Selected",
        oneItemShowing: "Showing 1 Item"
    },
    RichSelect: {
        newOptionLabel: "New",
        search: "search input"
    },
    Search: {
        placeholder: "Search"
    },
    DynamicSelect: {
        defaultError: "Error loading options",
        defaultEmptyText: "None available"
    },
    MetaItems: {
        notAvailable: "No Value"
    },
    Table: {
        collapseRow: "Collapse table row",
        expandRow: "Expand table row",
        menuCell: "Menu for row {rowId}",
        noItems: "No items found.",
        rowHeader: "Row Header",
        selectAll: "Select all",
        selectDisabled: "Selection Disabled",
        selectRow: "Select row {rowId}",
        sortAscending: "Sort Ascending",
        sortDescending: "Sort Descending",
        tableError: "Table Error",
        tableStatus: "Table Status",
        unexpectedValue: "Unexpected Value"
    },
    ToastNotification: {
        closeNotification: "Close Notification"
    },
    TreeSelect: {
        closedUAText: "Select to expand options",
        noResults: "No results found",
        openUAText: "Enter text to search or browse options in the Tree below, use up and down arrow keys to select items and right and left arrow keys to expand or collapse"
    }
};
bundled["ar-XB"] = {
    Common: {
        fullDate: "[‏‮{currentDateTime, date, fullDateTime}‬‏]",
        close: "[‏‮Close‬‏]",
        cancel: "[‏‮Cancel‬‏]",
        help: "[‏‮Help‬‏]",
        loading: "[‏‮Loading...‬‏]",
        required: "[‏‮Required‬‏]",
        actions: "[‏‮Actions‬‏]",
        show: "[‏‮Show‬‏]",
        submit: "[‏‮Submit‬‏]",
        hide: "[‏‮Hide‬‏]",
        moreInfo: "[‏‮More Information‬‏]",
        expand: "[‏‮Expand‬‏]",
        collapse: "[‏‮Collapse‬‏]",
        remove: "[‏‮Remove‬‏]"
    },
    Alert: {
        danger: "[‏‮Danger‬‏]",
        info: "[‏‮Info‬‏]",
        success: "[‏‮Success‬‏]",
        warning: "[‏‮Warning‬‏]"
    },
    Breadcrumb: {
        breadcrumb: "[‏‮Breadcrumb‬‏]"
    },
    DatePicker: {
        time: "[‏‮Time‬‏]"
    },
    DetailTemplate: {
        resources: "[‏‮Resources‬‏]"
    },
    Errors: {
        unexpectedError: "[‏‮An unexpected error occurred.‬‏]",
        unexpectedServiceError: "[‏‮An unexpected error from service occurred.‬‏]"
    },
    Field: {
        optional: "[‏‮Optional‬‏]",
        readOnly: "[‏‮Read-Only‬‏]"
    },
    FolderSelector: {
        browseLinkText: "[‏‮Select a folder‬‏]"
    },
    Clipboard: {
        copy: "[‏‮Copy‬‏]",
        copied: "[‏‮Copied‬‏]"
    },
    Pagination: {
        backToPage: "[‏‮Back to Page {page, number, integer}‬‏]",
        nextPage: "[‏‮Next Page‬‏]",
        nextToPage: "[‏‮Next to Page {page, number, integer}‬‏]",
        previousPage: "[‏‮Previous Page‬‏]",
        pageLocation: "[‏‮{currentPage, number, integer} of {totalPages, number, integer}‬‏]",
        pageLabel: "[‏‮Page {currentPage, number, integer}‬‏]"
    },
    ListingTemplate: {
        contentTitle: "[‏‮{resource} <em>in</em> {scope} <em>Compartment</em>‬‏]"
    },
    ListTable: {
        itemsShowing: "[‏‮Showing {items, number, integer} Items‬‏]",
        itemsSelected: "[‏‮{items, number, integer} Selected‬‏]",
        oneItemShowing: "[‏‮Showing 1 Item‬‏]"
    },
    RichSelect: {
        newOptionLabel: "[‏‮New‬‏]",
        search: "[‏‮search input‬‏]"
    },
    Search: {
        placeholder: "[‏‮Search‬‏]"
    },
    DynamicSelect: {
        defaultError: "[‏‮Error loading options‬‏]",
        defaultEmptyText: "[‏‮None available‬‏]"
    },
    MetaItems: {
        notAvailable: "[‏‮No Value‬‏]"
    },
    Table: {
        collapseRow: "[‏‮Collapse table row‬‏]",
        expandRow: "[‏‮Expand table row‬‏]",
        menuCell: "[‏‮Menu for row {rowId}‬‏]",
        noItems: "[‏‮No items found.‬‏]",
        rowHeader: "[‏‮Row Header‬‏]",
        selectAll: "[‏‮Select all‬‏]",
        selectDisabled: "[‏‮Selection Disabled‬‏]",
        selectRow: "[‏‮Select row {rowId}‬‏]",
        sortAscending: "[‏‮Sort Ascending‬‏]",
        sortDescending: "[‏‮Sort Descending‬‏]",
        tableError: "[‏‮Table Error‬‏]",
        tableStatus: "[‏‮Table Status‬‏]",
        unexpectedValue: "[‏‮Unexpected Value‬‏]"
    },
    ToastNotification: {
        closeNotification: "[‏‮Close Notification‬‏]"
    },
    TreeSelect: {
        closedUAText: "[‏‮Select to expand options‬‏]",
        noResults: "[‏‮No results found‬‏]",
        openUAText: "[‏‮Enter text to search or browse options in the Tree below, use up and down arrow keys to select items and right and left arrow keys to expand or collapse‬‏]"
    }
};
bundled["cs"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Zavřít",
        cancel: "Zrušit",
        help: "Nápověda",
        loading: "Načítání...",
        required: "Požadováno",
        actions: "Akce",
        show: "Zobrazit",
        submit: "Odeslat",
        hide: "Skrýt",
        moreInfo: "Více informací",
        expand: "Rozbalit",
        collapse: "Sbalit",
        remove: "Odebrat"
    },
    Alert: {
        danger: "Nebezpečí",
        info: "Informace",
        success: "Úspěch",
        warning: "Varování"
    },
    Breadcrumb: {
        breadcrumb: "Navigační cesta"
    },
    DatePicker: {
        time: "Čas"
    },
    DetailTemplate: {
        resources: "Zdroje"
    },
    Errors: {
        unexpectedError: "Vyskytla se neočekávaná chyba.",
        unexpectedServiceError: "Došlo k neočekávané chybě."
    },
    Field: {
        optional: "Nepovinné",
        readOnly: "Pouze ke čtení"
    },
    FolderSelector: {
        browseLinkText: "Vybrat složku"
    },
    Clipboard: {
        copy: "Kopírovat",
        copied: "Zkopírováno"
    },
    Pagination: {
        backToPage: "Zpět na stránku {page, number, integer}",
        nextPage: "Další stránka",
        nextToPage: "Na další stránku {page, number, integer}",
        previousPage: "Předchozí stránka",
        pageLocation: "{currentPage, number, integer} z {totalPages, number, integer}",
        pageLabel: "Stránka {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>v</em> <em>kompartmentu</em> {scope}"
    },
    ListTable: {
        itemsShowing: "Zobrazují se {items, number, integer} položky",
        itemsSelected: "Vybráno položek: {items, number, integer}",
        oneItemShowing: "Zobrazuje se 1 položka"
    },
    RichSelect: {
        newOptionLabel: "Vytvořit",
        search: "vstup pro vyhledávání"
    },
    Search: {
        placeholder: "Hledat"
    },
    DynamicSelect: {
        defaultError: "Chyba při načítání voleb",
        defaultEmptyText: "Není k dispozici"
    },
    MetaItems: {
        notAvailable: "Bez hodnoty"
    },
    Table: {
        collapseRow: "Sbalit řádek tabulky",
        expandRow: "Rozbalit řádek tabulky",
        menuCell: "Nabídka řádku {rowId}",
        noItems: "Nenalezeny žádné položky.",
        rowHeader: "Záhlaví řádku",
        selectAll: "Vybrat vše",
        selectDisabled: "Výběr dezaktivován",
        selectRow: "Vybrat řádek {rowId}",
        sortAscending: "Seřadit vzestupně",
        sortDescending: "Seřadí sestupně",
        tableError: "Chyba tabulky",
        tableStatus: "Stav tabulky",
        unexpectedValue: "Neočekávaná hodnota"
    },
    ToastNotification: {
        closeNotification: "Zavřít upozornění"
    },
    TreeSelect: {
        closedUAText: "Tyto volby vyberte pro rozbalení",
        noResults: "Nebyly nalezeny žádné výsledky",
        openUAText: "Zadejte text, podle kterého chcete prohledávat nebo procházejte volby ve stromě níže, pomocí kláves se šipkami nahoru a dolů vyberte položky a rozbalujte a sbalujte je kliknutím na klávesy s šipkami"
    }
};
bundled["da"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Luk",
        cancel: "Annuller",
        help: "Hjælp",
        loading: "Indlæser...",
        required: "Påkrævet",
        actions: "Handlinger",
        show: "Vis",
        submit: "Afsend",
        hide: "Skjul",
        moreInfo: "Flere oplysninger",
        expand: "Udvid",
        collapse: "Skjul",
        remove: "Fjern"
    },
    Alert: {
        danger: "Fare",
        info: "Info",
        success: "Succes",
        warning: "Advarsel"
    },
    Breadcrumb: {
        breadcrumb: "Brødkrumme"
    },
    DatePicker: {
        time: "Klokkeslæt"
    },
    DetailTemplate: {
        resources: "Ressourcer"
    },
    Errors: {
        unexpectedError: "Der opstod en uventet fejl.",
        unexpectedServiceError: "Der opstod en uventet fejl fra tjeneste."
    },
    Field: {
        optional: "Valgfri",
        readOnly: "Skrivebeskyttet"
    },
    FolderSelector: {
        browseLinkText: "Vælg en mappe"
    },
    Clipboard: {
        copy: "Kopier",
        copied: "Kopieret"
    },
    Pagination: {
        backToPage: "Tilbage til side {page, number, integer}",
        nextPage: "Næste side",
        nextToPage: "Videre til side {page, number, integer}",
        previousPage: "Forrige side",
        pageLocation: "{currentPage, number, integer} af {totalPages, number, integer}",
        pageLabel: "Side {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>i</em> {scope}<em>-rum</em>"
    },
    ListTable: {
        itemsShowing: "Viser {items, number, integer} elementer",
        itemsSelected: "{items, number, integer} valgt",
        oneItemShowing: "Viser 1 element"
    },
    RichSelect: {
        newOptionLabel: "Ny",
        search: "søgeinput"
    },
    Search: {
        placeholder: "Søg"
    },
    DynamicSelect: {
        defaultError: "Fejl ved indlæsning af indstillinger",
        defaultEmptyText: "Ingen tilgængelige"
    },
    MetaItems: {
        notAvailable: "Ingen værdi"
    },
    Table: {
        collapseRow: "Skjul tabelrække",
        expandRow: "Udvid tabelrække",
        menuCell: "Menu til rækken {rowId}",
        noItems: "Ingen elementer blev fundet.",
        rowHeader: "Rækkeoverskrift",
        selectAll: "Vælg alle",
        selectDisabled: "Valg deaktiveret",
        selectRow: "Vælg rækken {rowId}",
        sortAscending: "Sortér stigende",
        sortDescending: "Sortér faldende",
        tableError: "Tabelfejl",
        tableStatus: "Tabelstatus",
        unexpectedValue: "Uventet værdi"
    },
    ToastNotification: {
        closeNotification: "Luk besked"
    },
    TreeSelect: {
        closedUAText: "Vælg for at udvide valgmuligheder",
        noResults: "Der blev ikke fundet nogen resultater",
        openUAText: "Indtast tekst for at søge efter eller gennemse valgmuligheder i træet nedenfor. Brug op- og ned-piletasterne for at vælge elementer og højre- og venstre-piletasterne for at udvide eller skjule"
    }
};
bundled["de"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Schließen",
        cancel: "Abbrechen",
        help: "Hilfe",
        loading: "Wird geladen...",
        required: "Erforderlich",
        actions: "Aktionen",
        show: "Anzeigen",
        submit: "Weiterleiten",
        hide: "Ausblenden",
        moreInfo: "Weitere Informationen",
        expand: "Einblenden",
        collapse: "Ausblenden",
        remove: "Entfernen"
    },
    Alert: {
        danger: "Gefahr",
        info: "Info",
        success: "Erfolgreich",
        warning: "Warnung"
    },
    Breadcrumb: {
        breadcrumb: "Navigationspfad"
    },
    DatePicker: {
        time: "Zeit"
    },
    DetailTemplate: {
        resources: "Ressourcen"
    },
    Errors: {
        unexpectedError: "Ein unerwarteter Fehler ist aufgetreten.",
        unexpectedServiceError: "Es ist ein unerwarteter Fehler im Service aufgetreten."
    },
    Field: {
        optional: "Optional",
        readOnly: "Schreibgeschützt"
    },
    FolderSelector: {
        browseLinkText: "Wählen Sie einen Ordner aus"
    },
    Clipboard: {
        copy: "Kopieren",
        copied: "Kopiert"
    },
    Pagination: {
        backToPage: "Zurück zu Seite {page, number, integer}",
        nextPage: "Nächste Seite",
        nextToPage: "Zur nächsten Seite {page, number, integer}",
        previousPage: "Vorherige Seite",
        pageLocation: "{currentPage, number, integer} von {totalPages, number, integer}",
        pageLabel: "Seite {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>in</em> {scope} <em>Compartment</em>"
    },
    ListTable: {
        itemsShowing: "{items, number, integer} Elemente werden angezeigt",
        itemsSelected: "{items, number, integer} ausgewählt",
        oneItemShowing: "1 Element wird angezeigt"
    },
    RichSelect: {
        newOptionLabel: "Neu",
        search: "Sucheingabe"
    },
    Search: {
        placeholder: "Suchen"
    },
    DynamicSelect: {
        defaultError: "Fehler beim Laden von Optionen",
        defaultEmptyText: "Keine verfügbar"
    },
    MetaItems: {
        notAvailable: "Kein Wert"
    },
    Table: {
        collapseRow: "Tabellenzeile ausblenden",
        expandRow: "Tabellenzeile einblenden",
        menuCell: "Menü für Zeile {rowId}",
        noItems: "Keine Elemente gefunden.",
        rowHeader: "Zeilenheader",
        selectAll: "Alle auswählen",
        selectDisabled: "Auswahl deaktiviert",
        selectRow: "Zeile auswählen {rowId}",
        sortAscending: "Aufsteigend sortieren",
        sortDescending: "Absteigend sortieren",
        tableError: "Tabellenfehler",
        tableStatus: "Tabellenstatus",
        unexpectedValue: "Unerwarteter Wert"
    },
    ToastNotification: {
        closeNotification: "Benachrichtigung schließen"
    },
    TreeSelect: {
        closedUAText: "Wählen Sie diese Option zum Erweitern",
        noResults: "Keine Ergebnisse gefunden",
        openUAText: "Geben Sie den zu suchenden Text ein, oder durchsuchen Sie die Optionen im Baum unten. Elemente können Sie mit den Nach-oben- und Nach-unten-Tasten auswählen und mit den Nach-rechts- und Nach-links-Tasten ein- oder ausblenden."
    }
};
bundled["el"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Κλείσιμο",
        cancel: "Ακύρωση",
        help: "Βοήθεια",
        loading: "Γίνεται φόρτωση...",
        required: "Απαιτείται",
        actions: "Ενέργειες",
        show: "Εμφάνιση",
        submit: "Υποβολή",
        hide: "Απόκρυψη",
        moreInfo: "Περισσότερες πληροφορίες",
        expand: "Ανάπτυξη",
        collapse: "Σύμπτυξη",
        remove: "Κατάργηση"
    },
    Alert: {
        danger: "Κίνδυνος",
        info: "Πληροφορίες",
        success: "Επιτυχία",
        warning: "Προειδοποίηση"
    },
    Breadcrumb: {
        breadcrumb: "Στοιχείο διαδρομής"
    },
    DatePicker: {
        time: "Χρόνος"
    },
    DetailTemplate: {
        resources: "Πόροι"
    },
    Errors: {
        unexpectedError: "Παρουσιάστηκε μη αναμενόμενο σφάλμα.",
        unexpectedServiceError: "Παρουσιάστηκε μη αναμενόμενο σφάλμα από την υπηρεσία."
    },
    Field: {
        optional: "Προαιρετικά",
        readOnly: "Μόνο για ανάγνωση"
    },
    FolderSelector: {
        browseLinkText: "Επιλογή φακέλου"
    },
    Clipboard: {
        copy: "Αντιγραφή",
        copied: "Έγινε αντιγραφή"
    },
    Pagination: {
        backToPage: "Επιστροφή στη σελίδα {page, number, integer}",
        nextPage: "Επόμενη σελίδα",
        nextToPage: "Επόμενη σελίδα {page, number, integer}",
        previousPage: "Προηγούμενη σελίδα",
        pageLocation: "{currentPage, number, integer} από {totalPages, number, integer}",
        pageLabel: "Σελίδα {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>στο</em> {scope} <em>Διαμέρισμα</em>"
    },
    ListTable: {
        itemsShowing: "Εμφάνιση {items, number, integer} στοιχείων",
        itemsSelected: "{items, number, integer} επιλέχθηκαν",
        oneItemShowing: "Εμφάνιση 1 στοιχείου"
    },
    RichSelect: {
        newOptionLabel: "Νέα",
        search: "εισαγωγή δεδομένων αναζήτησης"
    },
    Search: {
        placeholder: "Αναζήτηση"
    },
    DynamicSelect: {
        defaultError: "Παρουσιάστηκε σφάλμα κατά τη φόρτωση των επιλογών",
        defaultEmptyText: "Κανένα διαθέσιμο"
    },
    MetaItems: {
        notAvailable: "Καμία τιμή"
    },
    Table: {
        collapseRow: "Σύμπτυξη σειράς πίνακα",
        expandRow: "Ανάπτυξη σειράς πίνακα",
        menuCell: "Μενού για σειρά {rowId}",
        noItems: "Δεν βρέθηκαν στοιχεία.",
        rowHeader: "Επικεφαλίδα γραμμής",
        selectAll: "Επιλογή όλων",
        selectDisabled: "Η επιλογή απενεργοποιήθηκε",
        selectRow: "Επιλογή σειράς {rowId}",
        sortAscending: "Ταξινόμηση σε αύξουσα σειρά",
        sortDescending: "Φθίνουσα ταξινόμηση",
        tableError: "Σφάλμα πίνακα",
        tableStatus: "Κατάσταση πίνακα",
        unexpectedValue: "Μη αναμενόμενη τιμή"
    },
    ToastNotification: {
        closeNotification: "Κλείσιμο ειδοποίησης"
    },
    TreeSelect: {
        closedUAText: "Επιλογές για ανάπτυξη",
        noResults: "Δεν βρέθηκαν αποτελέσματα",
        openUAText: "Καταχωρίστε κείμενο για αναζήτηση ή περιηγηθείτε στις επιλογές στο δέντρο παρακάτω. Χρησιμοποιήστε τα πλήκτρα επάνω και κάτω βέλους για να επιλέξετε στοιχεία και τα πλήκτρα αριστερού και δεξιού βέλους για επέκταση ή σύμπτυξη."
    }
};
bundled["en-XA"] = {
    Common: {
        fullDate: "[PX][{currentDateTime, date, fullDateTime} éëžéëž]",
        close: "[PX][Close é]",
        cancel: "[PX][Cancel é]",
        help: "[PX][Help é]",
        loading: "[PX][Loading... é]",
        required: "[PX][Required é]",
        actions: "[PX][Actions é]",
        show: "[PX][Show é]",
        submit: "[PX][Submit é]",
        hide: "[PX][Hide é]",
        moreInfo: "[PX][More Information é]",
        expand: "[PX][Expand é]",
        collapse: "[PX][Collapse é]",
        remove: "[PX][Remove é]"
    },
    Alert: {
        danger: "[PX][Danger é]",
        info: "[PX][Info é]",
        success: "[PX][Success é]",
        warning: "[PX][Warning é]"
    },
    Breadcrumb: {
        breadcrumb: "[PX][Breadcrumb é]"
    },
    DatePicker: {
        time: "[PX][Time é]"
    },
    DetailTemplate: {
        resources: "[PX][Resources é]"
    },
    Errors: {
        unexpectedError: "[PX][An unexpected error occurred. éëž]",
        unexpectedServiceError: "[PX][An unexpected error from service occurred. éëžéëžé]"
    },
    Field: {
        optional: "[PX][Optional é]",
        readOnly: "[PX][Read-Only é]"
    },
    FolderSelector: {
        browseLinkText: "[PX][Select a folder é]"
    },
    Clipboard: {
        copy: "[PX][Copy é]",
        copied: "[PX][Copied é]"
    },
    Pagination: {
        backToPage: "[PX][Back to Page {page, number, integer} éëžéë]",
        nextPage: "[PX][Next Page é]",
        nextToPage: "[PX][Next to Page {page, number, integer} éëžéë]",
        previousPage: "[PX][Previous Page é]",
        pageLocation: "[PX][{currentPage, number, integer} of {totalPages, number, integer} éëžéëžéëžéëžé]",
        pageLabel: "[PX][Page {currentPage, number, integer} éëžéë]"
    },
    ListingTemplate: {
        contentTitle: "[PX][{resource} <em>in</em> {scope} <em>Compartment</em> éëžéëžéëžé]"
    },
    ListTable: {
        itemsShowing: "[PX][Showing {items, number, integer} Items éëžéëž]",
        itemsSelected: "[PX][{items, number, integer} Selected éëžé]",
        oneItemShowing: "[PX][Showing 1 Item é]"
    },
    RichSelect: {
        newOptionLabel: "[PX][New é]",
        search: "[PX][search input é]"
    },
    Search: {
        placeholder: "[PX][Search é]"
    },
    DynamicSelect: {
        defaultError: "[PX][Error loading options é]",
        defaultEmptyText: "[PX][None available é]"
    },
    MetaItems: {
        notAvailable: "[PX][No Value é]"
    },
    Table: {
        collapseRow: "[PX][Collapse table row é]",
        expandRow: "[PX][Expand table row é]",
        menuCell: "[PX][Menu for row {rowId} é]",
        noItems: "[PX][No items found. é]",
        rowHeader: "[PX][Row Header é]",
        selectAll: "[PX][Select all é]",
        selectDisabled: "[PX][Selection Disabled é]",
        selectRow: "[PX][Select row {rowId} é]",
        sortAscending: "[PX][Sort Ascending é]",
        sortDescending: "[PX][Sort Descending é]",
        tableError: "[PX][Table Error é]",
        tableStatus: "[PX][Table Status é]",
        unexpectedValue: "[PX][Unexpected Value é]"
    },
    ToastNotification: {
        closeNotification: "[PX][Close Notification é]"
    },
    TreeSelect: {
        closedUAText: "[PX][Select to expand options éë]",
        noResults: "[PX][No results found é]",
        openUAText: "[PX][Enter text to search or browse options in the Tree below, use up and down arrow keys to select items and right and left arrow keys to expand or collapse éëžéëžéëžéëžéëžéëžéëžéëžéëžéëžéëžéëžéëžé]"
    }
};
bundled["en-XC"] = {
    Common: {
        fullDate: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:fullDate:::{currentDateTime, date, fullDateTime}]]",
        close: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:close:::Close]]",
        cancel: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:cancel:::Cancel]]",
        help: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:help:::Help]]",
        loading: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:loading:::Loading...]]",
        required: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:required:::Required]]",
        actions: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:actions:::Actions]]",
        show: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:show:::Show]]",
        submit: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:submit:::Submit]]",
        hide: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:hide:::Hide]]",
        moreInfo: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:moreInfo:::More Information]]",
        expand: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:expand:::Expand]]",
        collapse: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:collapse:::Collapse]]",
        remove: "[[oci_console_oui/packages/oui-react/locales/en.json:::Common:remove:::Remove]]"
    },
    Alert: {
        danger: "[[oci_console_oui/packages/oui-react/locales/en.json:::Alert:danger:::Danger]]",
        info: "[[oci_console_oui/packages/oui-react/locales/en.json:::Alert:info:::Info]]",
        success: "[[oci_console_oui/packages/oui-react/locales/en.json:::Alert:success:::Success]]",
        warning: "[[oci_console_oui/packages/oui-react/locales/en.json:::Alert:warning:::Warning]]"
    },
    Breadcrumb: {
        breadcrumb: "[[oci_console_oui/packages/oui-react/locales/en.json:::Breadcrumb:breadcrumb:::Breadcrumb]]"
    },
    DatePicker: {
        time: "[[oci_console_oui/packages/oui-react/locales/en.json:::DatePicker:time:::Time]]"
    },
    DetailTemplate: {
        resources: "[[oci_console_oui/packages/oui-react/locales/en.json:::DetailTemplate:resources:::Resources]]"
    },
    Errors: {
        unexpectedError: "[[oci_console_oui/packages/oui-react/locales/en.json:::Errors:unexpectedError:::An unexpected error occurred.]]",
        unexpectedServiceError: "[[oci_console_oui/packages/oui-react/locales/en.json:::Errors:unexpectedServiceError:::An unexpected error from service occurred.]]"
    },
    Field: {
        optional: "[[oci_console_oui/packages/oui-react/locales/en.json:::Field:optional:::Optional]]",
        readOnly: "[[oci_console_oui/packages/oui-react/locales/en.json:::Field:readOnly:::Read-Only]]"
    },
    FolderSelector: {
        browseLinkText: "[[oci_console_oui/packages/oui-react/locales/en.json:::FolderSelector:browseLinkText:::Select a folder]]"
    },
    Clipboard: {
        copy: "[[oci_console_oui/packages/oui-react/locales/en.json:::Clipboard:copy:::Copy]]",
        copied: "[[oci_console_oui/packages/oui-react/locales/en.json:::Clipboard:copied:::Copied]]"
    },
    Pagination: {
        backToPage: "[[oci_console_oui/packages/oui-react/locales/en.json:::Pagination:backToPage:::Back to Page {page, number, integer}]]",
        nextPage: "[[oci_console_oui/packages/oui-react/locales/en.json:::Pagination:nextPage:::Next Page]]",
        nextToPage: "[[oci_console_oui/packages/oui-react/locales/en.json:::Pagination:nextToPage:::Next to Page {page, number, integer}]]",
        previousPage: "[[oci_console_oui/packages/oui-react/locales/en.json:::Pagination:previousPage:::Previous Page]]",
        pageLocation: "[[oci_console_oui/packages/oui-react/locales/en.json:::Pagination:pageLocation:::{currentPage, number, integer} of {totalPages, number, integer}]]",
        pageLabel: "[[oci_console_oui/packages/oui-react/locales/en.json:::Pagination:pageLabel:::Page {currentPage, number, integer}]]"
    },
    ListingTemplate: {
        contentTitle: "[[oci_console_oui/packages/oui-react/locales/en.json:::ListingTemplate:contentTitle:::{resource} <em>in</em> {scope} <em>Compartment</em>]]"
    },
    ListTable: {
        itemsShowing: "[[oci_console_oui/packages/oui-react/locales/en.json:::ListTable:itemsShowing:::Showing {items, number, integer} Items]]",
        itemsSelected: "[[oci_console_oui/packages/oui-react/locales/en.json:::ListTable:itemsSelected:::{items, number, integer} Selected]]",
        oneItemShowing: "[[oci_console_oui/packages/oui-react/locales/en.json:::ListTable:oneItemShowing:::Showing 1 Item]]"
    },
    RichSelect: {
        newOptionLabel: "[[oci_console_oui/packages/oui-react/locales/en.json:::RichSelect:newOptionLabel:::New]]",
        search: "[[oci_console_oui/packages/oui-react/locales/en.json:::RichSelect:search:::search input]]"
    },
    Search: {
        placeholder: "[[oci_console_oui/packages/oui-react/locales/en.json:::Search:placeholder:::Search]]"
    },
    DynamicSelect: {
        defaultError: "[[oci_console_oui/packages/oui-react/locales/en.json:::DynamicSelect:defaultError:::Error loading options]]",
        defaultEmptyText: "[[oci_console_oui/packages/oui-react/locales/en.json:::DynamicSelect:defaultEmptyText:::None available]]"
    },
    MetaItems: {
        notAvailable: "[[oci_console_oui/packages/oui-react/locales/en.json:::MetaItems:notAvailable:::No Value]]"
    },
    Table: {
        collapseRow: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:collapseRow:::Collapse table row]]",
        expandRow: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:expandRow:::Expand table row]]",
        menuCell: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:menuCell:::Menu for row {rowId}]]",
        noItems: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:noItems:::No items found.]]",
        rowHeader: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:rowHeader:::Row Header]]",
        selectAll: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:selectAll:::Select all]]",
        selectDisabled: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:selectDisabled:::Selection Disabled]]",
        selectRow: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:selectRow:::Select row {rowId}]]",
        sortAscending: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:sortAscending:::Sort Ascending]]",
        sortDescending: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:sortDescending:::Sort Descending]]",
        tableError: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:tableError:::Table Error]]",
        tableStatus: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:tableStatus:::Table Status]]",
        unexpectedValue: "[[oci_console_oui/packages/oui-react/locales/en.json:::Table:unexpectedValue:::Unexpected Value]]"
    },
    ToastNotification: {
        closeNotification: "[[oci_console_oui/packages/oui-react/locales/en.json:::ToastNotification:closeNotification:::Close Notification]]"
    },
    TreeSelect: {
        closedUAText: "[[oci_console_oui/packages/oui-react/locales/en.json:::TreeSelect:closedUAText:::Select to expand options]]",
        noResults: "[[oci_console_oui/packages/oui-react/locales/en.json:::TreeSelect:noResults:::No results found]]",
        openUAText: "[[oci_console_oui/packages/oui-react/locales/en.json:::TreeSelect:openUAText:::Enter text to search or browse options in the Tree below, use up and down arrow keys to select items and right and left arrow keys to expand or collapse]]"
    }
};
bundled["en"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Close",
        cancel: "Cancel",
        help: "Help",
        loading: "Loading...",
        required: "Required",
        actions: "Actions",
        show: "Show",
        submit: "Submit",
        hide: "Hide",
        moreInfo: "More Information",
        expand: "Expand",
        collapse: "Collapse",
        remove: "Remove"
    },
    Alert: {
        danger: "Danger",
        info: "Info",
        success: "Success",
        warning: "Warning"
    },
    Breadcrumb: {
        breadcrumb: "Breadcrumb"
    },
    DatePicker: {
        time: "Time"
    },
    DetailTemplate: {
        resources: "Resources"
    },
    Errors: {
        unexpectedError: "An unexpected error occurred.",
        unexpectedServiceError: "An unexpected error from service occurred."
    },
    Field: {
        optional: "Optional",
        readOnly: "Read-Only"
    },
    FolderSelector: {
        browseLinkText: "Select a folder"
    },
    Clipboard: {
        copy: "Copy",
        copied: "Copied"
    },
    Pagination: {
        backToPage: "Back to Page {page, number, integer}",
        nextPage: "Next Page",
        nextToPage: "Next to Page {page, number, integer}",
        previousPage: "Previous Page",
        pageLocation: "{currentPage, number, integer} of {totalPages, number, integer}",
        pageLabel: "Page {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>in</em> {scope} <em>Compartment</em>"
    },
    ListTable: {
        itemsShowing: "Showing {items, number, integer} Items",
        itemsSelected: "{items, number, integer} Selected",
        oneItemShowing: "Showing 1 Item"
    },
    RichSelect: {
        newOptionLabel: "New",
        search: "search input"
    },
    Search: {
        placeholder: "Search"
    },
    DynamicSelect: {
        defaultError: "Error loading options",
        defaultEmptyText: "None available"
    },
    MetaItems: {
        notAvailable: "No Value"
    },
    Table: {
        collapseRow: "Collapse table row",
        expandRow: "Expand table row",
        menuCell: "Menu for row {rowId}",
        noItems: "No items found.",
        rowHeader: "Row Header",
        selectAll: "Select all",
        selectDisabled: "Selection Disabled",
        selectRow: "Select row {rowId}",
        sortAscending: "Sort Ascending",
        sortDescending: "Sort Descending",
        tableError: "Table Error",
        tableStatus: "Table Status",
        unexpectedValue: "Unexpected Value"
    },
    ToastNotification: {
        closeNotification: "Close Notification"
    },
    TreeSelect: {
        closedUAText: "Select to expand options",
        noResults: "No results found",
        openUAText: "Enter text to search or browse options in the Tree below, use up and down arrow keys to select items and right and left arrow keys to expand or collapse"
    }
};
bundled["es"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Cerrar",
        cancel: "Cancelar",
        help: "Ayuda",
        loading: "Cargando...",
        required: "Obligatorio",
        actions: "Acciones",
        show: "Mostrar",
        submit: "Enviar",
        hide: "Ocultar",
        moreInfo: "Más información",
        expand: "Ampliar",
        collapse: "Reducir",
        remove: "Eliminar"
    },
    Alert: {
        danger: "Peligro",
        info: "Información",
        success: "Correcto",
        warning: "Advertencia"
    },
    Breadcrumb: {
        breadcrumb: "Ruta de navegación"
    },
    DatePicker: {
        time: "Hora"
    },
    DetailTemplate: {
        resources: "Recursos"
    },
    Errors: {
        unexpectedError: "Se ha producido un error inesperado.",
        unexpectedServiceError: "Se ha producido un error inesperado del servicio."
    },
    Field: {
        optional: "Opcional",
        readOnly: "Solo lectura"
    },
    FolderSelector: {
        browseLinkText: "Seleccionar carpeta"
    },
    Clipboard: {
        copy: "Copiar",
        copied: "Copiado"
    },
    Pagination: {
        backToPage: "Volver a la página {page, number, integer}",
        nextPage: "Página siguiente",
        nextToPage: "Seguir en la página {page, number, integer}",
        previousPage: "Página anterior",
        pageLocation: "{currentPage, number, integer} de {totalPages, number, integer}",
        pageLabel: "Página {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>en</em> <em>compartimento</em> {scope}"
    },
    ListTable: {
        itemsShowing: "Mostrando {items, number, integer} elementos",
        itemsSelected: "{items, number, integer} seleccionado(s)",
        oneItemShowing: "Mostrando 1 elemento"
    },
    RichSelect: {
        newOptionLabel: "Nuevo",
        search: "entrada de búsqueda"
    },
    Search: {
        placeholder: "Buscar"
    },
    DynamicSelect: {
        defaultError: "Error al cargar opciones",
        defaultEmptyText: "Ninguno disponible"
    },
    MetaItems: {
        notAvailable: "Ningún valor"
    },
    Table: {
        collapseRow: "Reducir fila de tabla",
        expandRow: "Ampliar fila de tabla",
        menuCell: "Menú de fila {rowId}",
        noItems: "No se ha encontrado ningún elemento.",
        rowHeader: "Cabecera de Fila",
        selectAll: "Seleccionar todo",
        selectDisabled: "Selección desactivada",
        selectRow: "Seleccionar fila {rowId}",
        sortAscending: "Orden ascendente",
        sortDescending: "Orden descendente",
        tableError: "Error de tabla",
        tableStatus: "Estado de tabla",
        unexpectedValue: "Valor inesperado"
    },
    ToastNotification: {
        closeNotification: "Cerrar notificación"
    },
    TreeSelect: {
        closedUAText: "Seleccione para ampliar las opciones",
        noResults: "No se han encontrado resultados",
        openUAText: "Introduzca texto para buscar o examinar opciones en el árbol que aparece a continuación. Utilice las teclas de flecha hacia arriba y hacia abajo para seleccionar elementos y las teclas de flecha hacia la derecha y hacia la izquierda para ampliar o reducir."
    }
};
bundled["fi"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Sulje",
        cancel: "Peruuta",
        help: "Ohje",
        loading: "Ladataan...",
        required: "Pakollinen",
        actions: "Toimet",
        show: "Näytä",
        submit: "Lähetä",
        hide: "Piilota",
        moreInfo: "Lisätietoja",
        expand: "Laajenna",
        collapse: "Tiivistä",
        remove: "Poista"
    },
    Alert: {
        danger: "Vaara",
        info: "Tiedot",
        success: "Onnistui",
        warning: "Varoitus"
    },
    Breadcrumb: {
        breadcrumb: "Linkkipolku"
    },
    DatePicker: {
        time: "Aika"
    },
    DetailTemplate: {
        resources: "Resurssit"
    },
    Errors: {
        unexpectedError: "Odottamaton virhe",
        unexpectedServiceError: "Odottamaton virhe palvelussa."
    },
    Field: {
        optional: "Valinnainen",
        readOnly: "Vain luku"
    },
    FolderSelector: {
        browseLinkText: "Valitse kansio"
    },
    Clipboard: {
        copy: "Kopioi",
        copied: "Kopioitu"
    },
    Pagination: {
        backToPage: "Takaisin sivulle {page, number, integer}",
        nextPage: "Seuraava sivu",
        nextToPage: "Seuraavaksi sivulle {page, number, integer}",
        previousPage: "Edellinen sivu",
        pageLocation: "{currentPage, number, integer}/{totalPages, number, integer}",
        pageLabel: "Sivu {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>osastossa</em> {scope} <em></em>"
    },
    ListTable: {
        itemsShowing: "Näytetään {items, number, integer} kohdetta",
        itemsSelected: "{items, number, integer} valittu",
        oneItemShowing: "Näytetään 1 kohde"
    },
    RichSelect: {
        newOptionLabel: "Uusi",
        search: "haun syöte"
    },
    Search: {
        placeholder: "Haku"
    },
    DynamicSelect: {
        defaultError: "Virhe ladattaessa valintoja",
        defaultEmptyText: "Ei yhtään käytettävissä"
    },
    MetaItems: {
        notAvailable: "Ei arvoa"
    },
    Table: {
        collapseRow: "Tiivistä taulukkorivi",
        expandRow: "Laajenna taulukkorivi",
        menuCell: "Rivin {rowId} valikko",
        noItems: "Kohteita ei löydy.",
        rowHeader: "Riviotsikko",
        selectAll: "Valitse kaikki",
        selectDisabled: "Valinta poistettu käytöstä",
        selectRow: "Valitse rivi {rowId}",
        sortAscending: "Nouseva järjestys",
        sortDescending: "Laskeva järjestys",
        tableError: "Taulukon virhe",
        tableStatus: "Taulukon tila",
        unexpectedValue: "Odottamaton arvo"
    },
    ToastNotification: {
        closeNotification: "Sulje ilmoitus"
    },
    TreeSelect: {
        closedUAText: "Laajenna valintoja valitsemalla tämä",
        noResults: "Ei tuloksia",
        openUAText: "Hae kirjoittamalla tekstiä tai selaa alla olevan puun valintoja, valitse kohteita ylä- ja alanuolinäppäimillä ja laajenna tai tiivistä vasemmalla ja oikealla nuolinäppäimellä"
    }
};
bundled["fr-CA"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Fermer",
        cancel: "Annuler",
        help: "Aide",
        loading: "Chargement...",
        required: "Requis",
        actions: "Actions",
        show: "Afficher",
        submit: "Soumettre",
        hide: "Masquer",
        moreInfo: "Informations supplémentaires",
        expand: "Développer",
        collapse: "Réduire",
        remove: "Supprimer"
    },
    Alert: {
        danger: "Danger",
        info: "Informations",
        success: "Réussite",
        warning: "Avertissement"
    },
    Breadcrumb: {
        breadcrumb: "Chemin de navigation"
    },
    DatePicker: {
        time: "Heure"
    },
    DetailTemplate: {
        resources: "Ressources"
    },
    Errors: {
        unexpectedError: "Erreur inattendue.",
        unexpectedServiceError: "Une erreur imprévue du service est survenue."
    },
    Field: {
        optional: "Facultatif",
        readOnly: "Lecture seule"
    },
    FolderSelector: {
        browseLinkText: "Sélectionner un dossier"
    },
    Clipboard: {
        copy: "Copier",
        copied: "Copié"
    },
    Pagination: {
        backToPage: "Retour à la page {page, number, integer}",
        nextPage: "Page suivante",
        nextToPage: "Passage à la page {page, number, integer}",
        previousPage: "Page précédente",
        pageLocation: "{currentPage, number, integer} de {totalPages, number, integer}",
        pageLabel: "Page {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>in</em> {scope} <em>Compartiment</em>"
    },
    ListTable: {
        itemsShowing: "Affichage de {items, number, integer} articles",
        itemsSelected: "{items, number, integer} sélectionnés",
        oneItemShowing: "Affichage de 1 article"
    },
    RichSelect: {
        newOptionLabel: "Nouveau",
        search: "entrée de recherche"
    },
    Search: {
        placeholder: "Rechercher"
    },
    DynamicSelect: {
        defaultError: "Erreur lors du chargement des options",
        defaultEmptyText: "Rien de disponible"
    },
    MetaItems: {
        notAvailable: "Aucune valeur"
    },
    Table: {
        collapseRow: "Réduire la rangée de la table",
        expandRow: "Développer la rangée de la table",
        menuCell: "Menu pour la rangée {rowId}",
        noItems: "Aucun élément n'a été trouvé.",
        rowHeader: "En-tête de rangée",
        selectAll: "Tout sélectionner",
        selectDisabled: "Sélection désactivée",
        selectRow: "Sélectionner la rangée {rowId}",
        sortAscending: "Trier en ordre croissant",
        sortDescending: "Trier en ordre décroissant",
        tableError: "Erreur de table",
        tableStatus: "Statut de la table",
        unexpectedValue: "Valeur inattendue"
    },
    ToastNotification: {
        closeNotification: "Fermer l'avis"
    },
    TreeSelect: {
        closedUAText: "Sélectionner pour développer les options",
        noResults: "Aucun résultat trouvé",
        openUAText: "Entrez le texte à rechercher ou parcourez les options de l'arbre ci-dessous. Utilisez les flèches vers le haut et vers le bas pour sélectionner des éléments et les flèches vers la droite ou vers la gauche pour développer ou réduire la liste."
    }
};
bundled["fr"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Fermer",
        cancel: "Annuler",
        help: "Aide",
        loading: "Chargement...",
        required: "Obligatoire",
        actions: "Actions",
        show: "Afficher",
        submit: "Soumettre",
        hide: "Masquer",
        moreInfo: "Plus d'informations",
        expand: "Développer",
        collapse: "Réduire",
        remove: "Enlever"
    },
    Alert: {
        danger: "Danger",
        info: "Informations",
        success: "Succès",
        warning: "Avertissement"
    },
    Breadcrumb: {
        breadcrumb: "Chemin de navigation"
    },
    DatePicker: {
        time: "Heure"
    },
    DetailTemplate: {
        resources: "Ressources"
    },
    Errors: {
        unexpectedError: "Une erreur inattendue est survenue.",
        unexpectedServiceError: "Une erreur inattendue du service est survenue."
    },
    Field: {
        optional: "Facultatif",
        readOnly: "Lecture seule"
    },
    FolderSelector: {
        browseLinkText: "Sélectionner un dossier"
    },
    Clipboard: {
        copy: "Copier",
        copied: "Copié"
    },
    Pagination: {
        backToPage: "Revenir à la page {page, number, integer}",
        nextPage: "Page suivante",
        nextToPage: "Passer à la page {page, number, integer}",
        previousPage: "Page précédente",
        pageLocation: "{currentPage, number, integer} sur {totalPages, number, integer}",
        pageLabel: "Page {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>dans</em> le <em>compartiment</em> {scope}"
    },
    ListTable: {
        itemsShowing: "Affichage de {items, number, integer} éléments",
        itemsSelected: "{items, number, integer} sélectionné(s)",
        oneItemShowing: "Affichage d'un élément"
    },
    RichSelect: {
        newOptionLabel: "Nouveau",
        search: "entrée de recherche"
    },
    Search: {
        placeholder: "Rechercher"
    },
    DynamicSelect: {
        defaultError: "Erreur lors du chargement des options",
        defaultEmptyText: "Aucun élément disponible"
    },
    MetaItems: {
        notAvailable: "Aucune valeur"
    },
    Table: {
        collapseRow: "Réduire la ligne de table",
        expandRow: "Développer la ligne de table",
        menuCell: "Menu pour la ligne {rowId}",
        noItems: "Aucun élément trouvé.",
        rowHeader: "En-tête de ligne",
        selectAll: "Sélectionner tout",
        selectDisabled: "Sélection désactivée",
        selectRow: "Sélectionner la ligne {rowId}",
        sortAscending: "Trier par ordre croissant",
        sortDescending: "Tri par ordre décroissant",
        tableError: "Erreur de table",
        tableStatus: "Statut de table",
        unexpectedValue: "Valeur inattendue"
    },
    ToastNotification: {
        closeNotification: "Fermer la notification"
    },
    TreeSelect: {
        closedUAText: "Sélectionner pour développer les options",
        noResults: "Aucun résultat trouvé",
        openUAText: "Entrer le texte à rechercher ou parcourir les options dans l'arborescence ci-dessous, utiliser les touches fléchées vers le haut et vers le bas pour sélectionner des éléments, et les touches fléchées vers la droite et vers la gauche pour développer ou réduire"
    }
};
bundled["hr"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Zatvori",
        cancel: "Odustani",
        help: "Pomoć",
        loading: "Učitava se...",
        required: "Obavezno",
        actions: "Akcije",
        show: "Prikaži",
        submit: "Podnesi",
        hide: "Sakrij",
        moreInfo: "Više informacija",
        expand: "Proširi",
        collapse: "Sakrij",
        remove: "Ukloni"
    },
    Alert: {
        danger: "Opasnost",
        info: "Informacije",
        success: "Uspjeh",
        warning: "Upozorenje"
    },
    Breadcrumb: {
        breadcrumb: "Trag"
    },
    DatePicker: {
        time: "Vrijeme"
    },
    DetailTemplate: {
        resources: "Resursi"
    },
    Errors: {
        unexpectedError: "Došlo je do neočekivane pogreške.",
        unexpectedServiceError: "Došlo je do neočekivane pogreške servisa."
    },
    Field: {
        optional: "Nije obavezno",
        readOnly: "Samo za čitanje"
    },
    FolderSelector: {
        browseLinkText: "Odabir mape"
    },
    Clipboard: {
        copy: "Kopiraj",
        copied: "Kopirano"
    },
    Pagination: {
        backToPage: "Natrag na stranicu {page, number, integer}",
        nextPage: "Sljedeća stranica",
        nextToPage: "Naprijed na stranicu {page, number, integer}",
        previousPage: "Prethodna stranica",
        pageLocation: "{currentPage, number, integer} od {totalPages, number, integer}",
        pageLabel: "Stranica {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>u</em> {scope} <em>odjeljku</em>"
    },
    ListTable: {
        itemsShowing: "Prikazuje se sljedeći broj stavki: {items, number, integer}",
        itemsSelected: "Odabrano {items, number, integer}",
        oneItemShowing: "Prikazuje se 1 stavka"
    },
    RichSelect: {
        newOptionLabel: "Novo",
        search: "unos za pretraživanje"
    },
    Search: {
        placeholder: "Traži"
    },
    DynamicSelect: {
        defaultError: "Pogreška pri učitavanju opcija",
        defaultEmptyText: "Nema raspoloživih"
    },
    MetaItems: {
        notAvailable: "Nema vrijednosti"
    },
    Table: {
        collapseRow: "Sakrij redak tablice",
        expandRow: "Proširi redak tablice",
        menuCell: "Izbornik za redak {rowId}",
        noItems: "Nijedna stavka nije pronađena.",
        rowHeader: "Zaglavlje retka",
        selectAll: "Odaberi sve",
        selectDisabled: "Odabir onemogućen",
        selectRow: "Odaberi redak {rowId}",
        sortAscending: "Poredaj uzlazno",
        sortDescending: "Poredaj silazno",
        tableError: "Pogreška u tablici",
        tableStatus: "Status tablice",
        unexpectedValue: "Neočekivana vrijednost "
    },
    ToastNotification: {
        closeNotification: "Zatvori obavijest"
    },
    TreeSelect: {
        closedUAText: "Odaberite za proširenje opcija",
        noResults: "Rezult. nisu pronađeni",
        openUAText: "Unesite tekst za pretraživanje ili pregledajte opcije na donjem stablu, strelicama za gore i dolje možete odabrati stavke, a strelicama za lijevo i desno možete ih proširiti ili sakriti"
    }
};
bundled["hu"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Bezárás",
        cancel: "Mégse",
        help: "Súgó",
        loading: "Betöltés...",
        required: "Kötelező",
        actions: "Műveletek",
        show: "Megjelenítés",
        submit: "Küldés",
        hide: "Elrejtés",
        moreInfo: "További információk",
        expand: "Kibontás",
        collapse: "Összecsukás",
        remove: "Eltávolítás"
    },
    Alert: {
        danger: "Veszély",
        info: "Tájékoztatás",
        success: "Siker",
        warning: "Figyelmeztetés"
    },
    Breadcrumb: {
        breadcrumb: "Elérési útvonal"
    },
    DatePicker: {
        time: "Idő"
    },
    DetailTemplate: {
        resources: "Erőforrások"
    },
    Errors: {
        unexpectedError: "Váratlan hiba történt.",
        unexpectedServiceError: "Váratlan hiba történt a szolgáltatással kapcsolatban."
    },
    Field: {
        optional: "Választható",
        readOnly: "Írásvédett"
    },
    FolderSelector: {
        browseLinkText: "Mappa kijelölése"
    },
    Clipboard: {
        copy: "Másolás",
        copied: "Másolva"
    },
    Pagination: {
        backToPage: "Vissza a(z) {page, number, integer}. oldalra",
        nextPage: "Következő oldal",
        nextToPage: "Tovább a(z) {page, number, integer}. oldalra",
        previousPage: "Előző oldal",
        pageLocation: "{currentPage, number, integer} / {totalPages, number, integer}",
        pageLabel: "{currentPage, number, integer}. oldal"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>a(z)</em> {scope} <em>útválasztási szegmensben</em>"
    },
    ListTable: {
        itemsShowing: "{items, number, integer} elem megjelenítése",
        itemsSelected: "{items, number, integer} kijelölve",
        oneItemShowing: "1 elem megjelenítése"
    },
    RichSelect: {
        newOptionLabel: "Új",
        search: "Keresési kifejezés"
    },
    Search: {
        placeholder: "Keresés"
    },
    DynamicSelect: {
        defaultError: "Hiba történt a beállítások betöltésekor.",
        defaultEmptyText: "Nincs elérhető"
    },
    MetaItems: {
        notAvailable: "Nincs érték"
    },
    Table: {
        collapseRow: "Táblasor összecsukása",
        expandRow: "Táblasor kibontása",
        menuCell: "{rowId} sor menüje",
        noItems: "Nem található elem.",
        rowHeader: "Sor fejléce",
        selectAll: "Mindent kijelöl",
        selectDisabled: "Kijelölés letiltva",
        selectRow: "{rowId} sor kijelölése",
        sortAscending: "Növekvő sorrend",
        sortDescending: "Csökkenő sorrend",
        tableError: "Táblahiba",
        tableStatus: "Tábla állapota",
        unexpectedValue: "Nem várt érték"
    },
    ToastNotification: {
        closeNotification: "Értesítés bezárása"
    },
    TreeSelect: {
        closedUAText: "Jelölje ki a beállítások kibontásához",
        noResults: "Nincs találat",
        openUAText: "A kereséshez írja be a szöveget vagy tallózzon a beállítások között az alábbi fában. A Fel és Le nyíllal kijelölheti az elemeket, a Jobb és Bal nyíllal pedig kibonthatja vagy összecsukhatja azokat."
    }
};
bundled["it"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Chiudi",
        cancel: "Annulla",
        help: "?",
        loading: "Caricamento in corso...",
        required: "Obbligatorio",
        actions: "Azioni",
        show: "Mostra",
        submit: "Sottometti",
        hide: "Nascondi",
        moreInfo: "Più informazioni",
        expand: "Espandi",
        collapse: "Comprimi",
        remove: "Rimuovi"
    },
    Alert: {
        danger: "Pericolo",
        info: "Informazioni",
        success: "Operazione riuscita",
        warning: "Avvertenza"
    },
    Breadcrumb: {
        breadcrumb: "Indicatore di percorso"
    },
    DatePicker: {
        time: "Periodo"
    },
    DetailTemplate: {
        resources: "Risorse"
    },
    Errors: {
        unexpectedError: "Si è verificato un errore imprevisto.",
        unexpectedServiceError: "Si è verificato un errore imprevisto nel servizio."
    },
    Field: {
        optional: "Facoltativo",
        readOnly: "Sola lettura"
    },
    FolderSelector: {
        browseLinkText: "Selezionare una cartella"
    },
    Clipboard: {
        copy: "Copia",
        copied: "Copia eseguita"
    },
    Pagination: {
        backToPage: "Torna alla pagina {page, number, integer}",
        nextPage: "Pagina successiva",
        nextToPage: "Pagina successiva {page, number, integer}",
        previousPage: "Pagina precedente",
        pageLocation: "{currentPage, number, integer} di {totalPages, number, integer}",
        pageLabel: "Pagina {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>nel</em> <em>compartimento</em> {scope} "
    },
    ListTable: {
        itemsShowing: "Visualizzazione di {items, number, integer} elementi",
        itemsSelected: "{items, number, integer} selezionato/i",
        oneItemShowing: "Visualizzazione di 1 elemento"
    },
    RichSelect: {
        newOptionLabel: "Nuova",
        search: "input di ricerca"
    },
    Search: {
        placeholder: "Cerca"
    },
    DynamicSelect: {
        defaultError: "Errore durante il caricamento delle opzioni",
        defaultEmptyText: "Nessuno disponibile"
    },
    MetaItems: {
        notAvailable: "Nessun valore"
    },
    Table: {
        collapseRow: "Comprimi riga tabella",
        expandRow: "Espandi riga tabella",
        menuCell: "Menu per riga {rowId}",
        noItems: "Nessun elemento trovato.",
        rowHeader: "Intestazione riga",
        selectAll: "Seleziona tutto",
        selectDisabled: "Selezione disabilitata",
        selectRow: "Seleziona riga {rowId}",
        sortAscending: "Ordinamento crescente",
        sortDescending: "Ordinamento decrescente",
        tableError: "Errore tabella",
        tableStatus: "Stato tabella",
        unexpectedValue: "Valore imprevisto"
    },
    ToastNotification: {
        closeNotification: "Chiudi notifica"
    },
    TreeSelect: {
        closedUAText: "Selezionare per espandere le opzioni",
        noResults: "Nessun risult. trovato",
        openUAText: "Immettere il testo da cercare o sfogliare le opzioni nella struttura sottostante; utilizzare i tasti freccia su e giù per selezionare gli elementi e i tasti freccia destra e sinistra per espandere o comprimere"
    }
};
bundled["ja"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "閉じる",
        cancel: "取消",
        help: "ヘルプ",
        loading: "ロード中...",
        required: "必須",
        actions: "アクション",
        show: "表示",
        submit: "送信",
        hide: "非表示",
        moreInfo: "詳細情報",
        expand: "展開",
        collapse: "縮小",
        remove: "除去"
    },
    Alert: {
        danger: "危険",
        info: "情報",
        success: "成功",
        warning: "警告"
    },
    Breadcrumb: {
        breadcrumb: "ブレッドクラム"
    },
    DatePicker: {
        time: "時間"
    },
    DetailTemplate: {
        resources: "リソース"
    },
    Errors: {
        unexpectedError: "予期しないエラーが発生しました。",
        unexpectedServiceError: "予期しないエラーがサービスから発生しました。"
    },
    Field: {
        optional: "オプション",
        readOnly: "読取り専用"
    },
    FolderSelector: {
        browseLinkText: "フォルダを選択します"
    },
    Clipboard: {
        copy: "コピー",
        copied: "コピー済"
    },
    Pagination: {
        backToPage: "ページ{page, number, integer}に戻る",
        nextPage: "次のページ",
        nextToPage: "次のページ{page, number, integer}",
        previousPage: "前のページ",
        pageLocation: "{totalPages, number, integer}の{currentPage, number, integer}",
        pageLabel: "ページ{currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{scope}<em>コンパートメント</em><em>内の</em>{resource}"
    },
    ListTable: {
        itemsShowing: "{items, number, integer}アイテムを表示中",
        itemsSelected: "{items, number, integer}件を選択済",
        oneItemShowing: "1アイテムを表示中"
    },
    RichSelect: {
        newOptionLabel: "新規",
        search: "検索入力"
    },
    Search: {
        placeholder: "検索"
    },
    DynamicSelect: {
        defaultError: "オプションのロード中にエラーが発生しました",
        defaultEmptyText: "使用不可"
    },
    MetaItems: {
        notAvailable: "値なし"
    },
    Table: {
        collapseRow: "表の行の縮小",
        expandRow: "表の行の展開",
        menuCell: "行{rowId}のメニュー",
        noItems: "アイテムが見つかりませんでした。",
        rowHeader: "行ヘッダー",
        selectAll: "すべて選択",
        selectDisabled: "選択無効",
        selectRow: "行{rowId}の選択",
        sortAscending: "昇順にソート",
        sortDescending: "降順にソート",
        tableError: "表エラー",
        tableStatus: "表のステータス",
        unexpectedValue: "予期しない値"
    },
    ToastNotification: {
        closeNotification: "通知を閉じる"
    },
    TreeSelect: {
        closedUAText: "選択してオプションを展開します",
        noResults: "結果が見つかりませんでした",
        openUAText: "次のツリーに検索するテキストまたは参照オプションを入力し、上下の矢印キーを使用してアイテムを選択し、左右の矢印キーを使用して展開および縮小します"
    }
};
bundled["ko"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "닫기",
        cancel: "취소",
        help: "도움말",
        loading: "로드 중...",
        required: "필요",
        actions: "작업",
        show: "표시",
        submit: "제출",
        hide: "숨기기",
        moreInfo: "추가 정보",
        expand: "확장",
        collapse: "축소",
        remove: "제거"
    },
    Alert: {
        danger: "위험",
        info: "정보",
        success: "성공",
        warning: "경고"
    },
    Breadcrumb: {
        breadcrumb: "이동 경로"
    },
    DatePicker: {
        time: "시간"
    },
    DetailTemplate: {
        resources: "리소스"
    },
    Errors: {
        unexpectedError: "예상치 않은 오류가 발생했습니다.",
        unexpectedServiceError: "서비스에서 예상치 않은 오류가 발생했습니다."
    },
    Field: {
        optional: "선택사항",
        readOnly: "읽기 전용"
    },
    FolderSelector: {
        browseLinkText: "폴더 선택"
    },
    Clipboard: {
        copy: "복사",
        copied: "복사됨"
    },
    Pagination: {
        backToPage: "{page, number, integer}페이지로 돌아가기",
        nextPage: "다음 페이지",
        nextToPage: "다음 {page, number, integer}페이지로 이동",
        previousPage: "이전 페이지",
        pageLocation: "{currentPage, number, integer} / {totalPages, number, integer}",
        pageLabel: "{currentPage, number, integer}페이지"
    },
    ListingTemplate: {
        contentTitle: "{scope} <em>구획</em> <em>내</em> {resource}"
    },
    ListTable: {
        itemsShowing: "{items, number, integer}개 항목 표시 중",
        itemsSelected: "{items, number, integer}개 선택됨",
        oneItemShowing: "1개 항목 표시 중"
    },
    RichSelect: {
        newOptionLabel: "신규",
        search: "검색 입력"
    },
    Search: {
        placeholder: "검색"
    },
    DynamicSelect: {
        defaultError: "옵션 로드 중 오류 발생",
        defaultEmptyText: "사용할 수 있는 항목이 없음"
    },
    MetaItems: {
        notAvailable: "값 없음"
    },
    Table: {
        collapseRow: "테이블 행 축소",
        expandRow: "테이블 행 확장",
        menuCell: "{rowId} 행을 위한 메뉴",
        noItems: "항목을 찾을 수 없습니다.",
        rowHeader: "행 머리글",
        selectAll: "모두 선택",
        selectDisabled: "선택 사용 안함",
        selectRow: "{rowId} 행 선택",
        sortAscending: "오름차순 정렬",
        sortDescending: "내림차순 정렬",
        tableError: "테이블 오류",
        tableStatus: "테이블 상태",
        unexpectedValue: "예상치 않은 값"
    },
    ToastNotification: {
        closeNotification: "통지 닫기"
    },
    TreeSelect: {
        closedUAText: "옵션을 확장하려면 선택",
        noResults: "결과를 찾을 수 없습니다.",
        openUAText: "아래의 트리에서 옵션을 검색하거나 찾으려면 텍스트를 입력하고 위쪽/아래쪽 화살표 키를 사용하여 항목을 선택하고 오른쪽 및 왼쪽 화살표 키를 사용하여 확장 또는 축소하십시오."
    }
};
bundled["nl"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Sluiten",
        cancel: "Annuleren",
        help: "Help",
        loading: "Bezig met laden...",
        required: "Vereist",
        actions: "Acties",
        show: "Tonen",
        submit: "Versturen",
        hide: "Verbergen",
        moreInfo: "Meer informatie",
        expand: "Uitvouwen",
        collapse: "Samenvouwen",
        remove: "Verwijderen"
    },
    Alert: {
        danger: "Gevaar",
        info: "Info",
        success: "Geslaagd",
        warning: "Waarschuwing"
    },
    Breadcrumb: {
        breadcrumb: "Broodkruimel"
    },
    DatePicker: {
        time: "Tijd"
    },
    DetailTemplate: {
        resources: "Resources"
    },
    Errors: {
        unexpectedError: "Er is een onverwachte fout opgetreden.",
        unexpectedServiceError: "Er is een onverwachte servicefout opgetreden."
    },
    Field: {
        optional: "Optioneel",
        readOnly: "Alleen-lezen"
    },
    FolderSelector: {
        browseLinkText: "Een map selecteren"
    },
    Clipboard: {
        copy: "Kopiëren",
        copied: "Gekopieerd"
    },
    Pagination: {
        backToPage: "Naar vorige pagina {page, number, integer}",
        nextPage: "Volgende pagina",
        nextToPage: "Naar volgende pagina {page, number, integer}",
        previousPage: "Vorige pagina",
        pageLocation: "{currentPage, number, integer} van {totalPages, number, integer}",
        pageLabel: "Pagina {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>in</em> {scope} <em>compartiment</em>"
    },
    ListTable: {
        itemsShowing: "{items, number, integer} items worden weergegeven.",
        itemsSelected: "{items, number, integer} geselecteerd",
        oneItemShowing: "1 item wordt weergegeven."
    },
    RichSelect: {
        newOptionLabel: "Nieuw",
        search: "zoekinvoer"
    },
    Search: {
        placeholder: "Zoeken"
    },
    DynamicSelect: {
        defaultError: "Fout bij laden van opties",
        defaultEmptyText: "Geen beschikbaar"
    },
    MetaItems: {
        notAvailable: "Geen waarde"
    },
    Table: {
        collapseRow: "Tabelrij samenvouwen",
        expandRow: "Tabelrij uitvouwen",
        menuCell: "Menu voor rij {rowId}",
        noItems: "Er zijn geen items gevonden.",
        rowHeader: "Rijkop",
        selectAll: "Alles selecteren",
        selectDisabled: "Selectie inactief",
        selectRow: "Rij {rowId} selecteren",
        sortAscending: "Oplopend sorteren",
        sortDescending: "Aflopend sorteren",
        tableError: "Tabelfout",
        tableStatus: "Tabelstatus",
        unexpectedValue: "Onverwachte waarde"
    },
    ToastNotification: {
        closeNotification: "Melding sluiten"
    },
    TreeSelect: {
        closedUAText: "Selecteren om opties uit te vouwen",
        noResults: "Geen resultaten gevonden",
        openUAText: "Voer tekst in om opties in de onderstaande boomstructuur te doorzoeken of te doorbladeren. Gebruik de pijltoetsen omhoog en omlaag om items te selecteren, en de pijltoetsen naar rechts en links om uit te vouwen of samen te vouwen."
    }
};
bundled["no"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Lukk",
        cancel: "Avbryt",
        help: "Hjelp",
        loading: "Laster inn ...",
        required: "Obligatorisk",
        actions: "Handlinger",
        show: "Vis",
        submit: "Send",
        hide: "Skjul",
        moreInfo: "Flere opplysninger",
        expand: "Utvid",
        collapse: "Trekk sammen",
        remove: "Fjern"
    },
    Alert: {
        danger: "Fare",
        info: "Opplysninger",
        success: "Vellykket",
        warning: "Advarsel"
    },
    Breadcrumb: {
        breadcrumb: "Spor"
    },
    DatePicker: {
        time: "Tidspunkt"
    },
    DetailTemplate: {
        resources: "Ressurser"
    },
    Errors: {
        unexpectedError: "Det oppstod en uventet feil.",
        unexpectedServiceError: "Det oppstod en uventet feil i tjenesten."
    },
    Field: {
        optional: "Valgfritt",
        readOnly: "Skrivebeskyttet"
    },
    FolderSelector: {
        browseLinkText: "Velg en mappe"
    },
    Clipboard: {
        copy: "Kopier",
        copied: "Kopiert"
    },
    Pagination: {
        backToPage: "Tilbake til side {page, number, integer}",
        nextPage: "Neste side",
        nextToPage: "Videre til side {page, number, integer}",
        previousPage: "Forrige side",
        pageLocation: "{currentPage, number, integer} av {totalPages, number, integer}",
        pageLabel: "Side {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>i</em> <em>seksjonen</em> for {scope}"
    },
    ListTable: {
        itemsShowing: "Viser {items, number, integer} elementer",
        itemsSelected: "{items, number, integer} er valgt",
        oneItemShowing: "Viser 1 element"
    },
    RichSelect: {
        newOptionLabel: "Ny(tt)",
        search: "søkeinndata"
    },
    Search: {
        placeholder: "Søk"
    },
    DynamicSelect: {
        defaultError: "Feil ved innlasting av valg",
        defaultEmptyText: "Ingen tilgjengelige"
    },
    MetaItems: {
        notAvailable: "Ingen verdi"
    },
    Table: {
        collapseRow: "Trekk sammen tabellrad",
        expandRow: "Utvid tabellrad",
        menuCell: "Meny for rad {rowId}",
        noItems: "Fant ingen elementer.",
        rowHeader: "Radoverskrift",
        selectAll: "Velg alle",
        selectDisabled: "Valg deaktivert",
        selectRow: "Velg rad {rowId}",
        sortAscending: "Sorter stigende",
        sortDescending: "Sorter synkende",
        tableError: "Tabellfeil",
        tableStatus: "Tabellstatus",
        unexpectedValue: "Uventet verdi"
    },
    ToastNotification: {
        closeNotification: "Lukk varsling"
    },
    TreeSelect: {
        closedUAText: "Velg denne for å utvide valgene",
        noResults: "Finner ingen resultater",
        openUAText: "Skriv inn tekst for å søke, eller bla gjennom valgene i treet nedenfor. Bruk pil opp- og pil ned-tastene til å velge elementer og høyre og venstre piltast til å utvide eller trekke sammen."
    }
};
bundled["pl"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Zamknij",
        cancel: "Anuluj",
        help: "Pomoc",
        loading: "Ładowanie...",
        required: "Wymagane",
        actions: "Czynności",
        show: "Pokaż",
        submit: "Prześlij",
        hide: "Ukryj",
        moreInfo: "Więcej informacji",
        expand: "Rozwiń",
        collapse: "Zwiń",
        remove: "Usuń"
    },
    Alert: {
        danger: "Niebezpieczeństwo",
        info: "Informacje",
        success: "Powodzenie",
        warning: "Ostrzeżenie"
    },
    Breadcrumb: {
        breadcrumb: "Ślad"
    },
    DatePicker: {
        time: "Czas"
    },
    DetailTemplate: {
        resources: "Zasoby"
    },
    Errors: {
        unexpectedError: "Wystąpił nieoczekiwany błąd.",
        unexpectedServiceError: "Wystąpił nieoczekiwany błąd usługi."
    },
    Field: {
        optional: "Opcjonalne",
        readOnly: "Tylko do odczytu"
    },
    FolderSelector: {
        browseLinkText: "Wybór folderu"
    },
    Clipboard: {
        copy: "Kopiuj",
        copied: "Skopiowano"
    },
    Pagination: {
        backToPage: "Wstecz do strony {page, number, integer}",
        nextPage: "Następna strona",
        nextToPage: "Dalej do strony {page, number, integer}",
        previousPage: "Poprzednia strona",
        pageLocation: "{currentPage, number, integer} z {totalPages, number, integer}",
        pageLabel: "Strona {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: '{resource} <em>w</em> <em>przedziale</em> "{scope}"'
    },
    ListTable: {
        itemsShowing: "Pokazywane elementy: {items, number, integer}",
        itemsSelected: "Wybrane: {items, number, integer}",
        oneItemShowing: "Pokazywane elementy: 1"
    },
    RichSelect: {
        newOptionLabel: "Nowe",
        search: "dane wejściowe wyszukiwania"
    },
    Search: {
        placeholder: "Szukaj"
    },
    DynamicSelect: {
        defaultError: "Błąd podczas ładowania opcji",
        defaultEmptyText: "Brak dostępnych"
    },
    MetaItems: {
        notAvailable: "Brak wartości"
    },
    Table: {
        collapseRow: "Zwiń wiersz tabeli",
        expandRow: "Rozwiń wiersz tabeli",
        menuCell: "Menu dla wiersza {rowId}",
        noItems: "Nie znaleziono żadnego elementu.",
        rowHeader: "Nagłówek wiersza",
        selectAll: "Wybierz wszystkie",
        selectDisabled: "Wybór wyłączony",
        selectRow: "Wybierz wiersz {rowId}",
        sortAscending: "Sortuj rosnąco",
        sortDescending: "Sortuj malejąco",
        tableError: "Błąd tabeli",
        tableStatus: "Status tabeli",
        unexpectedValue: "Nieoczekiwana wartość"
    },
    ToastNotification: {
        closeNotification: "Zamknij powiadomienie"
    },
    TreeSelect: {
        closedUAText: "Proszę wybrać, aby rozwinąć opcje",
        noResults: "Brak wyników",
        openUAText: "Proszę wpisać szukany tekst lub przejrzeć opcje w poniższym drzewie; do wybierania elementów można używać klawiszy ze strzałką w górę/dół, a do rozwijania/zwijania - klawiszy ze strzałką w prawo/lewo"
    }
};
bundled["pt-PT"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Fechar",
        cancel: "Cancelar",
        help: "Auxílio",
        loading: "A carregar...",
        required: "Obrigatório",
        actions: "Ações",
        show: "Mostrar",
        submit: "Submeter",
        hide: "Ocultar",
        moreInfo: "Mais Informações",
        expand: "Expandir",
        collapse: "Contrair",
        remove: "Retirar"
    },
    Alert: {
        danger: "Perigo",
        info: "Informações",
        success: "Êxito",
        warning: "Aviso"
    },
    Breadcrumb: {
        breadcrumb: "Estrutura de Acesso"
    },
    DatePicker: {
        time: "Hora"
    },
    DetailTemplate: {
        resources: "Recursos"
    },
    Errors: {
        unexpectedError: "Ocorreu um erro inesperado.",
        unexpectedServiceError: "Ocorreu um erro de serviço inesperado."
    },
    Field: {
        optional: "Opcional",
        readOnly: "Só de Leitura"
    },
    FolderSelector: {
        browseLinkText: "Selecionar pasta"
    },
    Clipboard: {
        copy: "Copiar",
        copied: "Copiado"
    },
    Pagination: {
        backToPage: "Regressar à Página {page, number, integer}",
        nextPage: "Página Seguinte",
        nextToPage: "Página Seguinte {page, number, integer}",
        previousPage: "Página Anterior",
        pageLocation: "{currentPage, number, integer} de {totalPages, number, integer}",
        pageLabel: "Página {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>no</em> <em>Compartimento</em> {scope}"
    },
    ListTable: {
        itemsShowing: "A Mostrar {items, number, integer} Itens",
        itemsSelected: "{items, number, integer} Selecionado(s)",
        oneItemShowing: "A Mostrar 1 Item"
    },
    RichSelect: {
        newOptionLabel: "Novo",
        search: "pesquisar entrada de dados"
    },
    Search: {
        placeholder: "Pesquisar"
    },
    DynamicSelect: {
        defaultError: "Erro ao carregar as opções",
        defaultEmptyText: "Nenhum disponível"
    },
    MetaItems: {
        notAvailable: "Sem Valor"
    },
    Table: {
        collapseRow: "Contrair linha da tabela",
        expandRow: "Expandir linha da tabela",
        menuCell: "Menu para a linha {rowId}",
        noItems: "Não foi encontrado nenhum item.",
        rowHeader: "Cabeçalho da Linha",
        selectAll: "Selecionar todos",
        selectDisabled: "Seleção Desativada",
        selectRow: "Selecionar linha {rowId}",
        sortAscending: "Ordem Crescente",
        sortDescending: "Ordem Decrescente",
        tableError: "Erro da Tabela",
        tableStatus: "Estado da Tabela",
        unexpectedValue: "Valor Inesperado"
    },
    ToastNotification: {
        closeNotification: "Fechar Notificação"
    },
    TreeSelect: {
        closedUAText: "Selecione opções para expandir",
        noResults: "Sem resultados",
        openUAText: "Introduza texto para pesquisa ou percorra as opções na Árvore abaixo, utilize as teclas de seta para cima e para baixo para selecionar itens e as teclas da direita e da esquerda para expandir ou contrair"
    }
};
bundled["pt"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Fechar",
        cancel: "Cancelar",
        help: "Ajuda",
        loading: "Carregando...",
        required: "Obrigatório",
        actions: "Ações",
        show: "Mostrar",
        submit: "Submeter",
        hide: "Ocultar",
        moreInfo: "Mais Informações",
        expand: "Expandir",
        collapse: "Contrair",
        remove: "Remover"
    },
    Alert: {
        danger: "Perigo",
        info: "Informações",
        success: "Operação bem-sucedida",
        warning: "Advertência"
    },
    Breadcrumb: {
        breadcrumb: "Trilha de Navegação"
    },
    DatePicker: {
        time: "Horário"
    },
    DetailTemplate: {
        resources: "Recursos"
    },
    Errors: {
        unexpectedError: "Erro inesperado.",
        unexpectedServiceError: "Ocorreu um erro inesperado do serviço."
    },
    Field: {
        optional: "Opcional",
        readOnly: "Somente para Leitura"
    },
    FolderSelector: {
        browseLinkText: "Selecione uma pasta"
    },
    Clipboard: {
        copy: "Copiar",
        copied: "Copiado"
    },
    Pagination: {
        backToPage: "Voltar à Página {page, number, integer}",
        nextPage: "Próxima Página",
        nextToPage: "Próximo à Página {page, number, integer}",
        previousPage: "Página Anterior",
        pageLocation: "{currentPage, number, integer} de {totalPages, number, integer}",
        pageLabel: "Página {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>no</em> <em>Compartimento</em> {scope}"
    },
    ListTable: {
        itemsShowing: "Mostrando {items, number, integer} Itens",
        itemsSelected: "{items, number, integer} Selecionados",
        oneItemShowing: "Mostrando 1 item"
    },
    RichSelect: {
        newOptionLabel: "Nova",
        search: "pesquisar entrada"
    },
    Search: {
        placeholder: "Pesquisar"
    },
    DynamicSelect: {
        defaultError: "Erro ao carregar opções",
        defaultEmptyText: "Nenhum disponível"
    },
    MetaItems: {
        notAvailable: "Nenhum Valor"
    },
    Table: {
        collapseRow: "Contrair linha da tabela",
        expandRow: "Expandir linha da tabela",
        menuCell: "Menu para a linha {rowId}",
        noItems: "Nenhum item encontrado.",
        rowHeader: "Cabeçalho de Linha",
        selectAll: "Selecionar tudo",
        selectDisabled: "Seleção Desativada",
        selectRow: "Selecionar linha {rowId}",
        sortAscending: "Classificação em Ordem Crescente",
        sortDescending: "Classificação em Ordem Decrescente",
        tableError: "Erro de Tabela",
        tableStatus: "Status da Tabela",
        unexpectedValue: "Valor Inesperado"
    },
    ToastNotification: {
        closeNotification: "Fechar Notificação"
    },
    TreeSelect: {
        closedUAText: "Selecione para expandir opções",
        noResults: "Resultados não encontrados",
        openUAText: "Digite o texto a ser pesquisado ou navegue pelas opções na Árvore abaixo. Use as teclas de seta para cima e para baixo para selecionar itens e as teclas de seta para a direita e para a esquerda para expandir ou contrair"
    }
};
bundled["ro"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Închidere",
        cancel: "Anulare",
        help: "Asistenţă",
        loading: "Se încarcă...",
        required: "Obligatoriu",
        actions: "Acţiuni",
        show: "Afişare",
        submit: "Trimitere",
        hide: "Ascundere",
        moreInfo: "Mai multe informaţii",
        expand: "Extindere",
        collapse: "Restrângere",
        remove: "Eliminare"
    },
    Alert: {
        danger: "Pericol",
        info: "Informaţii",
        success: "Reuşită",
        warning: "Avertisment"
    },
    Breadcrumb: {
        breadcrumb: "Itinerar"
    },
    DatePicker: {
        time: "Oră"
    },
    DetailTemplate: {
        resources: "Resurse"
    },
    Errors: {
        unexpectedError: "A survenit o eroare neaşteptată.",
        unexpectedServiceError: "A avut loc o eroare neaşteptată a serviciului."
    },
    Field: {
        optional: "Opţional",
        readOnly: "Read-only"
    },
    FolderSelector: {
        browseLinkText: "Selectaţi un folder"
    },
    Clipboard: {
        copy: "Copiere",
        copied: "Copiat"
    },
    Pagination: {
        backToPage: "Înapoi la pagina {page, number, integer}",
        nextPage: "Pagina următoare",
        nextToPage: "Înainte la pagina {page, number, integer}",
        previousPage: "Pagina anterioară",
        pageLocation: "{currentPage, number, integer} din {totalPages, number, integer}",
        pageLabel: "Pagina {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>din</em> <em>compartimentul</em> {scope}"
    },
    ListTable: {
        itemsShowing: "Se afişează {items, number, integer} elemente",
        itemsSelected: "{items, number, integer} selectate",
        oneItemShowing: "Se afişează 1 element"
    },
    RichSelect: {
        newOptionLabel: "Creare",
        search: "intrare pentru căutare"
    },
    Search: {
        placeholder: "Căutare"
    },
    DynamicSelect: {
        defaultError: "Eroare la încărcarea opţiunilor",
        defaultEmptyText: "Nimic de afişat"
    },
    MetaItems: {
        notAvailable: "Nicio valoare"
    },
    Table: {
        collapseRow: "Restrângere rând tabel",
        expandRow: "Extindere rând tabel",
        menuCell: "Meniu pentru rândul {rowId}",
        noItems: "Nu a fost găsit niciun element.",
        rowHeader: "Antet rând",
        selectAll: "Selectare globală",
        selectDisabled: "Selectare dezactivată",
        selectRow: "Selectare rând {rowId}",
        sortAscending: "Sortare ascendentă",
        sortDescending: "Sortare descendentă",
        tableError: "Eroare tabel",
        tableStatus: "Stare tabel",
        unexpectedValue: "Valoare neaşteptată"
    },
    ToastNotification: {
        closeNotification: "Închidere înştiinţare"
    },
    TreeSelect: {
        closedUAText: "Selectaţi pentru a extinde opţiunile",
        noResults: "Nu au fost găsite rezultate",
        openUAText: "Introduceţi text pentru a căuta sau a parcurge opţiunile din arborele de mai jos. Utilizaţi tastele Săgeată sus şi Săgeată jos pentru a selecta articole şi tastele Săgeată dreapta şi Săgeată stânga pentru a extinde sau restrânge"
    }
};
bundled["ru"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Закрыть",
        cancel: "Отмена",
        help: "Справка",
        loading: "Загрузка...",
        required: "Обязательно",
        actions: "Действия",
        show: "Показать",
        submit: "Отправить",
        hide: "Скрыть",
        moreInfo: "Дополнительные сведения",
        expand: "Развернуть",
        collapse: "Свернуть",
        remove: "Удалить"
    },
    Alert: {
        danger: "Опасность",
        info: "Информация",
        success: "Выполнено успешно",
        warning: "Предупреждение"
    },
    Breadcrumb: {
        breadcrumb: "Путь навигации"
    },
    DatePicker: {
        time: "Время"
    },
    DetailTemplate: {
        resources: "Ресурсы"
    },
    Errors: {
        unexpectedError: "Возникла непредвиденная ошибка.",
        unexpectedServiceError: "Непредвиденная ошибка службы."
    },
    Field: {
        optional: "Необязательно",
        readOnly: "Только чтение"
    },
    FolderSelector: {
        browseLinkText: "Выбрать папку"
    },
    Clipboard: {
        copy: "Копировать",
        copied: "Скопировано"
    },
    Pagination: {
        backToPage: "Назад на страницу {page, number, integer}",
        nextPage: "Следующая страница",
        nextToPage: "Вперед на страницу {page, number, integer}",
        previousPage: "Предыдущая страница",
        pageLocation: "{currentPage, number, integer} из {totalPages, number, integer}",
        pageLabel: "Стр. {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>в</em> <em>отделении</em> {scope}"
    },
    ListTable: {
        itemsShowing: "Вывод {items, number, integer} позиций",
        itemsSelected: "{items, number, integer} выбрано",
        oneItemShowing: "Вывод 1 позиции"
    },
    RichSelect: {
        newOptionLabel: "Создать",
        search: "поиск ввода"
    },
    Search: {
        placeholder: "Поиск"
    },
    DynamicSelect: {
        defaultError: "Ошибка при загрузке параметров",
        defaultEmptyText: "Отсутствуют доступные"
    },
    MetaItems: {
        notAvailable: "Отсутствует значение"
    },
    Table: {
        collapseRow: "Свернуть строку таблицы",
        expandRow: "Развернуть строку таблицы",
        menuCell: "Меню строки {rowId}",
        noItems: "Элементы не найдены.",
        rowHeader: "Заголовок строки",
        selectAll: "Выделить все",
        selectDisabled: "Выбор отключен",
        selectRow: "Выбрать строку {rowId}",
        sortAscending: "Сортировка по возрастанию",
        sortDescending: "Сортировка по убыванию",
        tableError: "Ошибка таблицы",
        tableStatus: "Статус таблицы",
        unexpectedValue: "Непредвиденное значение"
    },
    ToastNotification: {
        closeNotification: "Закрыть уведомление"
    },
    TreeSelect: {
        closedUAText: "Выберите для развертывания параметров",
        noResults: "Результаты не найдены",
        openUAText: "Введите текст для поиска или найдите нужный вариант в дереве. Используйте клавиши со стрелками вверх и вниз для выбора элементов и клавиши со стрелками вправо и влево для развертывания/свертывания"
    }
};
bundled["sk"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Zavrieť",
        cancel: "Zrušiť",
        help: "Pomoc",
        loading: "Načítava sa...",
        required: "Povinné",
        actions: "Akcie",
        show: "Zobraziť",
        submit: "Odoslať",
        hide: "Skryť",
        moreInfo: "Ďalšie informácie",
        expand: "Rozbaliť",
        collapse: "Zbaliť",
        remove: "Odstrániť"
    },
    Alert: {
        danger: "Nebezpečenstvo",
        info: "Informácie",
        success: "Úspech",
        warning: "Upozornenie"
    },
    Breadcrumb: {
        breadcrumb: "Rýchla navigácia"
    },
    DatePicker: {
        time: "Čas"
    },
    DetailTemplate: {
        resources: "Prostriedky"
    },
    Errors: {
        unexpectedError: "Vyskytla sa neočakávaná chyba.",
        unexpectedServiceError: "Vyskytla sa neočakávaná chyba služby."
    },
    Field: {
        optional: "Voliteľné",
        readOnly: "Len na čítanie"
    },
    FolderSelector: {
        browseLinkText: "Vyberte priečinok"
    },
    Clipboard: {
        copy: "Kopírovať",
        copied: "Skopírované"
    },
    Pagination: {
        backToPage: "Späť na stránku {page, number, integer}",
        nextPage: "Ďalšia stránka",
        nextToPage: "Ďalej na stránku {page, number, integer}",
        previousPage: "Predchádzajúca stránka",
        pageLocation: "{currentPage, number, integer} z {totalPages, number, integer}",
        pageLabel: "Stránka {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>v</em> <em>kompartmente</em> {scope}"
    },
    ListTable: {
        itemsShowing: "Počet zobrazených položiek: {items, number, integer}",
        itemsSelected: "Počet vybraných položiek: {items, number, integer}",
        oneItemShowing: "Zobrazuje sa 1 položka"
    },
    RichSelect: {
        newOptionLabel: "Nové",
        search: "vstupná hodnota vyhľadávania"
    },
    Search: {
        placeholder: "Vyhľadať"
    },
    DynamicSelect: {
        defaultError: "Chyba pri načítavaní volieb",
        defaultEmptyText: "Žiadne k dispozícii"
    },
    MetaItems: {
        notAvailable: "Žiadna hodnota"
    },
    Table: {
        collapseRow: "Zbaliť riadok tabuľky",
        expandRow: "Rozbaliť riadok tabuľky",
        menuCell: "Ponuka pre riadok {rowId}",
        noItems: "Nenašli sa žiadne položky.",
        rowHeader: "Hlavička riadka",
        selectAll: "Vybrať všetko",
        selectDisabled: "Výber deaktivovaný",
        selectRow: "Vybrať riadok {rowId}",
        sortAscending: "Usporiadať vzostupne",
        sortDescending: "Usporiadať zostupne",
        tableError: "Chyba tabuľky",
        tableStatus: "Stav tabuľky",
        unexpectedValue: "Neočakávaná hodnota"
    },
    ToastNotification: {
        closeNotification: "Zavrieť upozornenie"
    },
    TreeSelect: {
        closedUAText: "Vyberte na rozbalenie volieb",
        noResults: "Nenašli sa výsledky",
        openUAText: "Zadajte text na vyhľadanie alebo prehľadajte voľby v strome nižšie, pomocou klávesov so šípkami nahor a nadol vyberte položky a pomocou klávesov so šípkami doprava a doľava rozbaľte alebo zbaľte"
    }
};
bundled["sl"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Zapri",
        cancel: "Prekliči",
        help: "Pomoč",
        loading: "Nalaganje ...",
        required: "Zahtevano",
        actions: "Dejanja",
        show: "Pokaži",
        submit: "Pošlji",
        hide: "Skrij",
        moreInfo: "Več informacij",
        expand: "Razširi",
        collapse: "Strni",
        remove: "Odstrani"
    },
    Alert: {
        danger: "Nevarnost",
        info: "Informacije",
        success: "Uspeh",
        warning: "Opozorilo"
    },
    Breadcrumb: {
        breadcrumb: "Sled"
    },
    DatePicker: {
        time: "Čas"
    },
    DetailTemplate: {
        resources: "Vir"
    },
    Errors: {
        unexpectedError: "Prišlo je do nepričakovane napake.",
        unexpectedServiceError: "Prišlo je do nepričakovane napake storitve."
    },
    Field: {
        optional: "Izbirno",
        readOnly: "Samo za branje"
    },
    FolderSelector: {
        browseLinkText: "Izberite mapo"
    },
    Clipboard: {
        copy: "Kopiraj",
        copied: "Kopirano"
    },
    Pagination: {
        backToPage: "Nazaj na stran {page, number, integer}",
        nextPage: "Naslednja stran",
        nextToPage: "Naprej na stran {page, number, integer}",
        previousPage: "Prejšnja stran",
        pageLocation: "{currentPage, number, integer} od {totalPages, number, integer}",
        pageLabel: "Stran {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>v razdelku</em> {scope} <em></em>"
    },
    ListTable: {
        itemsShowing: "Prikazanih je toliko elementov: {items, number, integer}",
        itemsSelected: "Izbrano: {items, number, integer}",
        oneItemShowing: "Prikazan je 1 element"
    },
    RichSelect: {
        newOptionLabel: "Novo",
        search: "vnos iskanja"
    },
    Search: {
        placeholder: "Iskanje"
    },
    DynamicSelect: {
        defaultError: "Napaka pri nalaganju možnosti",
        defaultEmptyText: "Ni razpoložljivih"
    },
    MetaItems: {
        notAvailable: "Ni vrednosti"
    },
    Table: {
        collapseRow: "Strni vrstico tabele",
        expandRow: "Razširi vrstico tabele",
        menuCell: "Meni za vrstico {rowId}",
        noItems: "Ni najdenih elementov.",
        rowHeader: "Glava vrstice",
        selectAll: "Izberi vse",
        selectDisabled: "Izbiranje onemogočeno",
        selectRow: "Izberi vrstico {rowId}",
        sortAscending: "Razvrsti naraščajoče",
        sortDescending: "Razvrsti padajoče",
        tableError: "Napaka tabele",
        tableStatus: "Status tabele",
        unexpectedValue: "Nepričakovana vrednost"
    },
    ToastNotification: {
        closeNotification: "Zapri obvestilo"
    },
    TreeSelect: {
        closedUAText: "Izberite za razširitev možnosti",
        noResults: "Ni najdenih rezultatov",
        openUAText: "Vnesite besedilo za iskanje ali prebrskajte možnosti v drevesu spodaj. Uporabite tipki s puščico navzgor in navzdol, da izberete elemente, in tipki s puščico desno in levo, da razširite ali strnete seznam."
    }
};
bundled["sr-Latn"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Zatvori",
        cancel: "Otkaži",
        help: "Pomoć",
        loading: "Učitava se...",
        required: "Obavezno",
        actions: "Radnje",
        show: "Prikaži",
        submit: "Prosledi",
        hide: "Sakrij",
        moreInfo: "Više informacija",
        expand: "Raširi",
        collapse: "Skupi",
        remove: "Ukloni"
    },
    Alert: {
        danger: "Opasnost",
        info: "Informacije",
        success: "Uspešno",
        warning: "Upozorenje"
    },
    Breadcrumb: {
        breadcrumb: "Skraćena putanja"
    },
    DatePicker: {
        time: "Vreme"
    },
    DetailTemplate: {
        resources: "Resursi"
    },
    Errors: {
        unexpectedError: "Došlo je do neočekivane greške.",
        unexpectedServiceError: "Došlo je do neočekivane greške u usluzi."
    },
    Field: {
        optional: "Opcionalno",
        readOnly: "Samo za čitanje"
    },
    FolderSelector: {
        browseLinkText: "Izaberite fasciklu"
    },
    Clipboard: {
        copy: "Kopiraj",
        copied: "Kopirano"
    },
    Pagination: {
        backToPage: "Nazad na stranicu {page, number, integer}",
        nextPage: "Sledeća stranica",
        nextToPage: "Dalje na stranicu {page, number, integer}",
        previousPage: "Prethodna stranica",
        pageLocation: "{currentPage, number, integer} od {totalPages, number, integer}",
        pageLabel: "Stranica {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>u</em> <em>odeljku</em> {scope}"
    },
    ListTable: {
        itemsShowing: "Prikaz više stavki ({items, number, integer})",
        itemsSelected: "Izabrano: {items, number, integer}",
        oneItemShowing: "Prikazivanje 1 stavke"
    },
    RichSelect: {
        newOptionLabel: "Novo",
        search: "unos za pretragu"
    },
    Search: {
        placeholder: "Pretraga"
    },
    DynamicSelect: {
        defaultError: "Greška prilikom učitavanja opcija",
        defaultEmptyText: "Nije dostupno"
    },
    MetaItems: {
        notAvailable: "Nema vrednost"
    },
    Table: {
        collapseRow: "Skupi red tabele",
        expandRow: "Raširi red tabele",
        menuCell: "Meni za red {rowId}",
        noItems: "Nije pronađena nijedna stavka.",
        rowHeader: "Zaglavlje reda",
        selectAll: "Izaberi sve",
        selectDisabled: "Izbor je onemogućen",
        selectRow: "Izaberite red {rowId}",
        sortAscending: "Sortiraj po rastućem redosledu",
        sortDescending: "Sortiraj po opadajućem redosledu",
        tableError: "Greška tabele",
        tableStatus: "Status tabele",
        unexpectedValue: "Neočekivana vrednost"
    },
    ToastNotification: {
        closeNotification: "Zatvaranje obaveštenja"
    },
    TreeSelect: {
        closedUAText: "Izaberite da biste razvili opcije",
        noResults: "Rezultati nisu pronađeni",
        openUAText: "Unesite tekst ili pregledajte opcije na stablu u nastavku. Koristite tastere sa strelicama nagore i nadole da biste izabrali stavke, a tastere sa strelicama ulevo i udesno da biste proširili ili skupili prikaz"
    }
};
bundled["sr"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Затвори",
        cancel: "Откажи",
        help: "Помоћ",
        loading: "Учитава се...",
        required: "Обавезно",
        actions: "Радње",
        show: "Прикажи",
        submit: "Проследи",
        hide: "Сакриј",
        moreInfo: "Више информација",
        expand: "Рашири",
        collapse: "Скупи",
        remove: "Уклони"
    },
    Alert: {
        danger: "Опасност",
        info: "Информације",
        success: "Успешно",
        warning: "Упозорење"
    },
    Breadcrumb: {
        breadcrumb: "Скраћена путања"
    },
    DatePicker: {
        time: "Време"
    },
    DetailTemplate: {
        resources: "Ресурси"
    },
    Errors: {
        unexpectedError: "Дошло је до неочекиване грешке.",
        unexpectedServiceError: "Дошло је до неочекиване грешке у услузи."
    },
    Field: {
        optional: "Опционално",
        readOnly: "Само за читање"
    },
    FolderSelector: {
        browseLinkText: "Изаберите фасциклу"
    },
    Clipboard: {
        copy: "Копирај",
        copied: "Копирано"
    },
    Pagination: {
        backToPage: "Назад на страницу {page, number, integer}",
        nextPage: "Следећа страница",
        nextToPage: "Даље на страницу {page, number, integer}",
        previousPage: "Претходна страница",
        pageLocation: "{currentPage, number, integer} од {totalPages, number, integer}",
        pageLabel: "Страница {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>у</em> <em>одељку</em> {scope}"
    },
    ListTable: {
        itemsShowing: "Приказ више ставки ({items, number, integer})",
        itemsSelected: "Изабрано: {items, number, integer}",
        oneItemShowing: "Приказивање 1 ставке"
    },
    RichSelect: {
        newOptionLabel: "Ново",
        search: "унос за претрагу"
    },
    Search: {
        placeholder: "Претрага"
    },
    DynamicSelect: {
        defaultError: "Грешка приликом учитавања опција",
        defaultEmptyText: "Није доступно"
    },
    MetaItems: {
        notAvailable: "Нема вредност"
    },
    Table: {
        collapseRow: "Скупи ред табеле",
        expandRow: "Рашири ред табеле",
        menuCell: "Мени за ред {rowId}",
        noItems: "Није пронађена ниједна ставка.",
        rowHeader: "Заглавље реда",
        selectAll: "Изабери све",
        selectDisabled: "Избор је онемогућен",
        selectRow: "Изаберите ред {rowId}",
        sortAscending: "Сортирај по растућем редоследу",
        sortDescending: "Сортирај по опадајућем редоследу",
        tableError: "Грешка табеле",
        tableStatus: "Статус табеле",
        unexpectedValue: "Неочекивана вредност"
    },
    ToastNotification: {
        closeNotification: "Затварање обавештења"
    },
    TreeSelect: {
        closedUAText: "Изаберите да бисте развили опције",
        noResults: "Резултати нису пронађени",
        openUAText: "Унесите текст или прегледајте опције на стаблу у наставку. Користите тастере са стрелицама нагоре и надоле да бисте изабрали ставке, а тастере са стрелицама улево и удесно да бисте проширили или скупили приказ"
    }
};
bundled["sv"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Stäng",
        cancel: "Avbryt",
        help: "Hjälp",
        loading: "Laddar...",
        required: "Obligatoriskt",
        actions: "Åtgärder",
        show: "Visa",
        submit: "Skicka",
        hide: "Dölj",
        moreInfo: "Mer information",
        expand: "Expandera",
        collapse: "Komprimera",
        remove: "Ta bort"
    },
    Alert: {
        danger: "Fara",
        info: "Information",
        success: "Utfördes",
        warning: "Varning"
    },
    Breadcrumb: {
        breadcrumb: "Navigeringsspår"
    },
    DatePicker: {
        time: "Tid"
    },
    DetailTemplate: {
        resources: "Resurser"
    },
    Errors: {
        unexpectedError: "Ett oväntat fel har inträffat.",
        unexpectedServiceError: "Ett oväntat fel har inträffat i tjänsten."
    },
    Field: {
        optional: "Valfritt",
        readOnly: "Skrivskyddat"
    },
    FolderSelector: {
        browseLinkText: "Välj en mapp"
    },
    Clipboard: {
        copy: "Kopiera",
        copied: "Kopierad"
    },
    Pagination: {
        backToPage: "Tillbaka till sidan {page, number, integer}",
        nextPage: "Nästa sida",
        nextToPage: "Gå till {page, number, integer}",
        previousPage: "Föregående sida",
        pageLocation: "{currentPage, number, integer} av {totalPages, number, integer}",
        pageLabel: "Sida {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>i</em> {scope}<em>-delområdet</em>"
    },
    ListTable: {
        itemsShowing: "Visar {items, number, integer} objekt",
        itemsSelected: "{items, number, integer} valda",
        oneItemShowing: "Visar 1 objekt"
    },
    RichSelect: {
        newOptionLabel: "Ny",
        search: "indata vid sökning"
    },
    Search: {
        placeholder: "Sök"
    },
    DynamicSelect: {
        defaultError: "Fel när alternativ skulle laddas",
        defaultEmptyText: "Ingen tillgänglig"
    },
    MetaItems: {
        notAvailable: "Inget värde"
    },
    Table: {
        collapseRow: "Komprimera tabellrad",
        expandRow: "Expandera tabellrad",
        menuCell: "Meny för rad {rowId}",
        noItems: "Hittade inga poster.",
        rowHeader: "Radhuvud",
        selectAll: "Välj alla",
        selectDisabled: "Urval är inaktivt",
        selectRow: "Välj rad {rowId}",
        sortAscending: "Sortera i stigande ordning",
        sortDescending: "Sortera i fallande ordning",
        tableError: "Tabellfel",
        tableStatus: "Tabellstatus",
        unexpectedValue: "Oväntat värde"
    },
    ToastNotification: {
        closeNotification: "Stäng meddelande"
    },
    TreeSelect: {
        closedUAText: "Välj för att expandera alternativ",
        noResults: "Inget resultat",
        openUAText: "Ange text för att söka efter eller bläddra bland alternativen i trädet nedan. Använd uppåt- och nedåtpilarna för att markera objekt och höger- och vänsterpilarna för att expandera eller komprimera"
    }
};
bundled["th"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "ปิด",
        cancel: "ยกเลิก",
        help: "วิธีใช้",
        loading: "กำลังโหลด...",
        required: "ต้องระบุ",
        actions: "การดำเนินการ",
        show: "แสดง",
        submit: "ส่ง",
        hide: "ซ่อน",
        moreInfo: "ข้อมูลเพิ่มเติม",
        expand: "ขยาย",
        collapse: "ยุบ",
        remove: "ย้ายออก"
    },
    Alert: {
        danger: "อันตราย",
        info: "ข้อมูล",
        success: "ความสำเร็จ",
        warning: "คำเตือน"
    },
    Breadcrumb: {
        breadcrumb: "Breadcrumb"
    },
    DatePicker: {
        time: "เวลา"
    },
    DetailTemplate: {
        resources: "ทรัพยากร"
    },
    Errors: {
        unexpectedError: "เกิดข้อผิดพลาดที่ไม่คาดหมาย",
        unexpectedServiceError: "เกิดข้อผิดพลาดจากบริการที่ไม่คาดหมาย"
    },
    Field: {
        optional: "เลือกระบุได้",
        readOnly: "แบบอ่านอย่างเดียว"
    },
    FolderSelector: {
        browseLinkText: "เลือกโฟลเดอร์"
    },
    Clipboard: {
        copy: "คัดลอก",
        copied: "คัดลอกแล้ว"
    },
    Pagination: {
        backToPage: "กลับสู่เพจ {page, number, integer}",
        nextPage: "เพจถัดไป",
        nextToPage: "ถัดจากเพจ {page, number, integer}",
        previousPage: "เพจก่อนหน้า",
        pageLocation: "{currentPage, number, integer} จาก {totalPages, number, integer}",
        pageLabel: "เพจ {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{resource} <em>ในคอมพาร์ทเมนต์</em> {scope} <em></em>"
    },
    ListTable: {
        itemsShowing: "กำลังแสดง {items, number, integer} รายการ",
        itemsSelected: "{items, number, integer} ที่เลือก",
        oneItemShowing: "กำลังแสดง 1 รายการ"
    },
    RichSelect: {
        newOptionLabel: "ใหม่",
        search: "ค้นหาอินพุต"
    },
    Search: {
        placeholder: "ค้นหา"
    },
    DynamicSelect: {
        defaultError: "เกิดข้อผิดพลาดขณะโหลดตัวเลือก",
        defaultEmptyText: "ไม่มีรายการที่ใช้ได้"
    },
    MetaItems: {
        notAvailable: "ไม่มีค่า"
    },
    Table: {
        collapseRow: "ยุบแถวตาราง",
        expandRow: "ขยายแถวตาราง",
        menuCell: "เมนูสำหรับแถว {rowId}",
        noItems: "ไม่พบรายการใด",
        rowHeader: "ส่วนหัวของแถว",
        selectAll: "เลือกทั้งหมด",
        selectDisabled: "เลิกใช้การเลือก",
        selectRow: "เลือกแถว {rowId}",
        sortAscending: "เรียงลำดับจากน้อยไปหามาก",
        sortDescending: "เรียงลำดับจากมากไปหาน้อย",
        tableError: "ข้อผิดพลาดของตาราง",
        tableStatus: "สถานะตาราง",
        unexpectedValue: "ค่าที่ไม่คาดหมาย"
    },
    ToastNotification: {
        closeNotification: "ปิดการแจ้ง"
    },
    TreeSelect: {
        closedUAText: "เลือกเพื่อขยายตัวเลือก",
        noResults: "ไม่พบผลลัพธ์",
        openUAText: "ป้อนข้อความที่จะค้นหาหรือเบราส์ตัวเลือกในทรีด้านล่าง ใช้ปุ่มลูกศรชี้ขึ้นหรือลงเพื่อเลือกรายการ และลูกศรชี้ขวาหรือซ้ายเพื่อยุบหรือขยาย"
    }
};
bundled["tr"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "Kapat",
        cancel: "İptal",
        help: "Yardım",
        loading: "Yükleniyor...",
        required: "Gerekli",
        actions: "Eylemler",
        show: "Göster",
        submit: "Gönder",
        hide: "Gizle",
        moreInfo: "Diğer Bilgiler",
        expand: "Genişlet",
        collapse: "Daralt",
        remove: "Kaldır"
    },
    Alert: {
        danger: "Tehlike",
        info: "Bilgi",
        success: "Başarılı",
        warning: "Uyarı"
    },
    Breadcrumb: {
        breadcrumb: "Görsel navigasyon yardımı"
    },
    DatePicker: {
        time: "Zaman"
    },
    DetailTemplate: {
        resources: "Kaynaklar"
    },
    Errors: {
        unexpectedError: "Beklenmeyen hata oluştu",
        unexpectedServiceError: "Servisten beklenmeyen hata oluştu."
    },
    Field: {
        optional: "İsteğe Bağlı",
        readOnly: "Salt Okunur"
    },
    FolderSelector: {
        browseLinkText: "Klasör seçin"
    },
    Clipboard: {
        copy: "Kopyala",
        copied: "Kopyalandı"
    },
    Pagination: {
        backToPage: "{page, number, integer} Sayfasına Dön",
        nextPage: "Sonraki Sayfa",
        nextToPage: "{page, number, integer} Sayfasına İlerle",
        previousPage: "Önceki Sayfa",
        pageLocation: "{currentPage, number, integer} / {totalPages, number, integer}",
        pageLabel: "Sayfa {currentPage, number, integer}"
    },
    ListingTemplate: {
        contentTitle: "{scope} <em>Bölmesi</em> <em>içindeki</em> {resource}"
    },
    ListTable: {
        itemsShowing: "{items, number, integer} Öğe Gösteriliyor",
        itemsSelected: "{items, number, integer} Seçildi",
        oneItemShowing: "1 Öğe Gösteriliyor"
    },
    RichSelect: {
        newOptionLabel: "Yeni",
        search: "arama girdisi"
    },
    Search: {
        placeholder: "Ara"
    },
    DynamicSelect: {
        defaultError: "Seçenekleri yükleme hatası",
        defaultEmptyText: "Kullanılabilen yok"
    },
    MetaItems: {
        notAvailable: "Değer Yok"
    },
    Table: {
        collapseRow: "Tablo satırını daralt",
        expandRow: "Tablo satırını genişlet",
        menuCell: "{rowId} satırı için menü",
        noItems: "Öğe bulunmadı.",
        rowHeader: "Satır Başlığı",
        selectAll: "Tümünü seç",
        selectDisabled: "Seçim Devre Dışı",
        selectRow: "{rowId} satırını seç",
        sortAscending: "Artan Sıralama",
        sortDescending: "Azalan Sıralama",
        tableError: "Tablo Hatası",
        tableStatus: "Tablo Statüsü",
        unexpectedValue: "Beklenmeyen Değer"
    },
    ToastNotification: {
        closeNotification: "Bildirimi Kapat"
    },
    TreeSelect: {
        closedUAText: "Seçenekleri genişletmek için seçin",
        noResults: "Sonuç bulunamadı",
        openUAText: "Arama metni girin veya aşağıdaki Ağaç'ta bulunan seçeneklere gözatın. Nesneleri seçmek için yukarı ve aşağı ok tuşlarını, genişletmek veya daraltmak için sol ve sağ ok tuşlarını kullanın."
    }
};
bundled["zh-Hans"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "关闭",
        cancel: "取消",
        help: "帮助",
        loading: "正在加载...",
        required: "必需",
        actions: "操作",
        show: "显示",
        submit: "提交",
        hide: "隐藏",
        moreInfo: "更多信息",
        expand: "展开",
        collapse: "折叠",
        remove: "删除"
    },
    Alert: {
        danger: "危险",
        info: "Info",
        success: "成功",
        warning: "警告"
    },
    Breadcrumb: {
        breadcrumb: "痕迹"
    },
    DatePicker: {
        time: "时间"
    },
    DetailTemplate: {
        resources: "资源"
    },
    Errors: {
        unexpectedError: "发生意外错误。",
        unexpectedServiceError: "服务发生意外错误。"
    },
    Field: {
        optional: "可选",
        readOnly: "只读"
    },
    FolderSelector: {
        browseLinkText: "选择文件夹"
    },
    Clipboard: {
        copy: "复制",
        copied: "已复制"
    },
    Pagination: {
        backToPage: "返回第 {page, number, integer} 页",
        nextPage: "下一页",
        nextToPage: "前进到第 {page, number, integer} 页",
        previousPage: "上一页",
        pageLocation: "{currentPage, number, integer}/{totalPages, number, integer}",
        pageLabel: "第 {currentPage, number, integer} 页"
    },
    ListingTemplate: {
        contentTitle: "<em></em>{scope} <em>区间中的</em> {resource}"
    },
    ListTable: {
        itemsShowing: "显示 {items, number, integer} 项",
        itemsSelected: "已选择 {items, number, integer} 项",
        oneItemShowing: "显示 1 项"
    },
    RichSelect: {
        newOptionLabel: "新建",
        search: "搜索输入"
    },
    Search: {
        placeholder: "搜索"
    },
    DynamicSelect: {
        defaultError: "加载选项时出错",
        defaultEmptyText: "无可用项"
    },
    MetaItems: {
        notAvailable: "无值"
    },
    Table: {
        collapseRow: "折叠表行",
        expandRow: "展开表行",
        menuCell: "行 {rowId} 的菜单",
        noItems: "找不到任何项。",
        rowHeader: "行标题",
        selectAll: "全选",
        selectDisabled: "已禁用选择",
        selectRow: "选择第 {rowId} 行",
        sortAscending: "升序排序",
        sortDescending: "降序排序",
        tableError: "表错误",
        tableStatus: "表状态",
        unexpectedValue: "意外值"
    },
    ToastNotification: {
        closeNotification: "关闭通知"
    },
    TreeSelect: {
        closedUAText: "选择以展开选项",
        noResults: "未找到任何结果",
        openUAText: "输入要搜索的文本，或浏览下面树中的选项，使用向上键和向下键选择项，并使用向左键和向右键展开或折叠"
    }
};
bundled["zh-Hant"] = {
    Common: {
        fullDate: "{currentDateTime, date, fullDateTime}",
        close: "關閉",
        cancel: "取消",
        help: "說明",
        loading: "載入中...",
        required: "必要",
        actions: "動作",
        show: "顯示",
        submit: "送出",
        hide: "隱藏",
        moreInfo: "更多資訊",
        expand: "展開",
        collapse: "隱藏",
        remove: "移除"
    },
    Alert: {
        danger: "危險",
        info: "資訊",
        success: "成功",
        warning: "警告"
    },
    Breadcrumb: {
        breadcrumb: "來源路徑"
    },
    DatePicker: {
        time: "時間"
    },
    DetailTemplate: {
        resources: "資源"
    },
    Errors: {
        unexpectedError: "發生未預期的錯誤.",
        unexpectedServiceError: "服務發生未預期的錯誤."
    },
    Field: {
        optional: "選擇性",
        readOnly: "唯讀"
    },
    FolderSelector: {
        browseLinkText: "選擇資料夾"
    },
    Clipboard: {
        copy: "複製",
        copied: "已複製"
    },
    Pagination: {
        backToPage: "返回第 {page, number, integer} 頁",
        nextPage: "下一頁",
        nextToPage: "移至第 {page, number, integer} 頁",
        previousPage: "上一頁",
        pageLocation: "{currentPage, number, integer} / {totalPages, number, integer}",
        pageLabel: "第 {currentPage, number, integer} 頁"
    },
    ListingTemplate: {
        contentTitle: "{scope} <em>區間</em><em>中</em>的{resource}"
    },
    ListTable: {
        itemsShowing: "顯示 {items, number, integer} 個項目",
        itemsSelected: "已選取 {items, number, integer} 個",
        oneItemShowing: "顯示 1 個項目"
    },
    RichSelect: {
        newOptionLabel: "新增",
        search: "搜尋輸入值"
    },
    Search: {
        placeholder: "搜尋"
    },
    DynamicSelect: {
        defaultError: "載入選項時發生錯誤",
        defaultEmptyText: "沒有可用的項目"
    },
    MetaItems: {
        notAvailable: "沒有值"
    },
    Table: {
        collapseRow: "隱藏表格資料列",
        expandRow: "展開表格資料列",
        menuCell: "{rowId} 資料列功能表",
        noItems: "找不到項目.",
        rowHeader: "資料列標頭",
        selectAll: "全選",
        selectDisabled: "選取已停用",
        selectRow: "選取資料列 {rowId}",
        sortAscending: "遞增排序",
        sortDescending: "遞減排序",
        tableError: "表格錯誤",
        tableStatus: "表格狀態",
        unexpectedValue: "未預期的值"
    },
    ToastNotification: {
        closeNotification: "關閉通知"
    },
    TreeSelect: {
        closedUAText: "選取展開選項",
        noResults: "找不到任何結果",
        openUAText: "輸入文字以搜尋或瀏覽下方樹狀結構中的選項, 使用向上鍵和向下鍵可選取項目, 使用向右鍵和向左鍵則可進一步展開或隱藏"
    }
};
var i18n = new loom_i18n_1.LoomI18n();
/**
 * Initialize the instance. If no {@code defaultLanguage} are provided, tries to automatically detect the language
 * @param defaultLanguage The language to use initially
 */
function init(defaultLanguage) {
    i18n.initSync({
        defaultLanguage: defaultLanguage,
        resources: bundled,
        localesData: {
            en: en_1.default,
            ar: ar_1.default,
            cs: cs_1.default,
            da: da_1.default,
            de: de_1.default,
            el: el_1.default,
            es: es_1.default,
            fi: fi_1.default,
            fr: fr_1.default,
            hr: hr_1.default,
            hu: hu_1.default,
            it: it_1.default,
            ja: ja_1.default,
            ko: ko_1.default,
            nl: nl_1.default,
            no: no_1.default,
            pl: pl_1.default,
            pt: pt_1.default,
            ro: ro_1.default,
            ru: ru_1.default,
            sk: sk_1.default,
            sl: sl_1.default,
            sr: sr_1.default,
            sv: sv_1.default,
            th: th_1.default,
            tr: tr_1.default,
            zh: zh_1.default
        }
    });
}
exports.init = init;
/**
 * Add a notification callback on initialization time. Please set this before you call @method init
 * @param callback
 */
function onInit(callback) {
    i18n.onInit(callback);
}
exports.onInit = onInit;
/**
 * Add a notification callback on missing translation key. Useful for applicatons that may need to do
 * work once the translation key is missing in translation files.
 * @param callback
 */
function onMissingKey(callback) {
    i18n.onMissingKey(callback);
}
exports.onMissingKey = onMissingKey;
function isInit() {
    return i18n.isInitialized;
}
exports.isInit = isInit;
/**
 * Change the language of the current instance.
 * @param language New language to use. Can be either language code (e.g. "en"), or locale code (e.g. "en-US"))
 */
function changeLanguage(language) {
    return i18n.changeLanguage(language);
}
exports.changeLanguage = changeLanguage;
/**
 * Add a notification callback on change of language. Useful for applications that may need
 * to do work once the language is changed (e.g. forceUpdate of the root component in react)
 * @param callback
 */
function onLanguageChanged(callback) {
    i18n.onLanguageChanged(callback);
}
exports.onLanguageChanged = onLanguageChanged;
exports.Common = {
    fullDate: function Common_fullDate(currentDateTime) {
        return i18n.t("Common.fullDate", { currentDateTime: currentDateTime });
    },
    close: function Common_close() {
        return i18n.t("Common.close", {});
    },
    cancel: function Common_cancel() {
        return i18n.t("Common.cancel", {});
    },
    help: function Common_help() {
        return i18n.t("Common.help", {});
    },
    loading: function Common_loading() {
        return i18n.t("Common.loading", {});
    },
    required: function Common_required() {
        return i18n.t("Common.required", {});
    },
    actions: function Common_actions() {
        return i18n.t("Common.actions", {});
    },
    show: function Common_show() {
        return i18n.t("Common.show", {});
    },
    submit: function Common_submit() {
        return i18n.t("Common.submit", {});
    },
    hide: function Common_hide() {
        return i18n.t("Common.hide", {});
    },
    moreInfo: function Common_moreInfo() {
        return i18n.t("Common.moreInfo", {});
    },
    expand: function Common_expand() {
        return i18n.t("Common.expand", {});
    },
    collapse: function Common_collapse() {
        return i18n.t("Common.collapse", {});
    },
    remove: function Common_remove() {
        return i18n.t("Common.remove", {});
    }
};
exports.Alert = {
    danger: function Alert_danger() {
        return i18n.t("Alert.danger", {});
    },
    info: function Alert_info() {
        return i18n.t("Alert.info", {});
    },
    success: function Alert_success() {
        return i18n.t("Alert.success", {});
    },
    warning: function Alert_warning() {
        return i18n.t("Alert.warning", {});
    }
};
exports.Breadcrumb = {
    breadcrumb: function Breadcrumb_breadcrumb() {
        return i18n.t("Breadcrumb.breadcrumb", {});
    }
};
exports.DatePicker = {
    time: function DatePicker_time() {
        return i18n.t("DatePicker.time", {});
    }
};
exports.DetailTemplate = {
    resources: function DetailTemplate_resources() {
        return i18n.t("DetailTemplate.resources", {});
    }
};
exports.Errors = {
    unexpectedError: function Errors_unexpectedError() {
        return i18n.t("Errors.unexpectedError", {});
    },
    unexpectedServiceError: function Errors_unexpectedServiceError() {
        return i18n.t("Errors.unexpectedServiceError", {});
    }
};
exports.Field = {
    optional: function Field_optional() {
        return i18n.t("Field.optional", {});
    },
    readOnly: function Field_readOnly() {
        return i18n.t("Field.readOnly", {});
    }
};
exports.FolderSelector = {
    browseLinkText: function FolderSelector_browseLinkText() {
        return i18n.t("FolderSelector.browseLinkText", {});
    }
};
exports.Clipboard = {
    copy: function Clipboard_copy() {
        return i18n.t("Clipboard.copy", {});
    },
    copied: function Clipboard_copied() {
        return i18n.t("Clipboard.copied", {});
    }
};
exports.Pagination = {
    backToPage: function Pagination_backToPage(page) {
        return i18n.t("Pagination.backToPage", { page: page });
    },
    nextPage: function Pagination_nextPage() {
        return i18n.t("Pagination.nextPage", {});
    },
    nextToPage: function Pagination_nextToPage(page) {
        return i18n.t("Pagination.nextToPage", { page: page });
    },
    previousPage: function Pagination_previousPage() {
        return i18n.t("Pagination.previousPage", {});
    },
    pageLocation: function Pagination_pageLocation(currentPage, totalPages) {
        return i18n.t("Pagination.pageLocation", { currentPage: currentPage, totalPages: totalPages });
    },
    pageLabel: function Pagination_pageLabel(currentPage) {
        return i18n.t("Pagination.pageLabel", { currentPage: currentPage });
    }
};
exports.ListingTemplate = {
    contentTitle: function ListingTemplate_contentTitle(resource, scope) {
        return i18n.t("ListingTemplate.contentTitle", { resource: resource, scope: scope });
    }
};
exports.ListTable = {
    itemsShowing: function ListTable_itemsShowing(items) {
        return i18n.t("ListTable.itemsShowing", { items: items });
    },
    itemsSelected: function ListTable_itemsSelected(items) {
        return i18n.t("ListTable.itemsSelected", { items: items });
    },
    oneItemShowing: function ListTable_oneItemShowing() {
        return i18n.t("ListTable.oneItemShowing", {});
    }
};
exports.RichSelect = {
    newOptionLabel: function RichSelect_newOptionLabel() {
        return i18n.t("RichSelect.newOptionLabel", {});
    },
    search: function RichSelect_search() {
        return i18n.t("RichSelect.search", {});
    }
};
exports.Search = {
    placeholder: function Search_placeholder() {
        return i18n.t("Search.placeholder", {});
    }
};
exports.DynamicSelect = {
    defaultError: function DynamicSelect_defaultError() {
        return i18n.t("DynamicSelect.defaultError", {});
    },
    defaultEmptyText: function DynamicSelect_defaultEmptyText() {
        return i18n.t("DynamicSelect.defaultEmptyText", {});
    }
};
exports.MetaItems = {
    notAvailable: function MetaItems_notAvailable() {
        return i18n.t("MetaItems.notAvailable", {});
    }
};
exports.Table = {
    collapseRow: function Table_collapseRow() {
        return i18n.t("Table.collapseRow", {});
    },
    expandRow: function Table_expandRow() {
        return i18n.t("Table.expandRow", {});
    },
    menuCell: function Table_menuCell(rowId) {
        return i18n.t("Table.menuCell", { rowId: rowId });
    },
    noItems: function Table_noItems() {
        return i18n.t("Table.noItems", {});
    },
    rowHeader: function Table_rowHeader() {
        return i18n.t("Table.rowHeader", {});
    },
    selectAll: function Table_selectAll() {
        return i18n.t("Table.selectAll", {});
    },
    selectDisabled: function Table_selectDisabled() {
        return i18n.t("Table.selectDisabled", {});
    },
    selectRow: function Table_selectRow(rowId) {
        return i18n.t("Table.selectRow", { rowId: rowId });
    },
    sortAscending: function Table_sortAscending() {
        return i18n.t("Table.sortAscending", {});
    },
    sortDescending: function Table_sortDescending() {
        return i18n.t("Table.sortDescending", {});
    },
    tableError: function Table_tableError() {
        return i18n.t("Table.tableError", {});
    },
    tableStatus: function Table_tableStatus() {
        return i18n.t("Table.tableStatus", {});
    },
    unexpectedValue: function Table_unexpectedValue() {
        return i18n.t("Table.unexpectedValue", {});
    }
};
exports.ToastNotification = {
    closeNotification: function ToastNotification_closeNotification() {
        return i18n.t("ToastNotification.closeNotification", {});
    }
};
exports.TreeSelect = {
    closedUAText: function TreeSelect_closedUAText() {
        return i18n.t("TreeSelect.closedUAText", {});
    },
    noResults: function TreeSelect_noResults() {
        return i18n.t("TreeSelect.noResults", {});
    },
    openUAText: function TreeSelect_openUAText() {
        return i18n.t("TreeSelect.openUAText", {});
    }
};
//# sourceMappingURL=Messages.js.map